import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  GlobalID: string;
  JSON: any;
  JSONString: any;
  Time: any;
};

export type ActiveSessionType = {
  __typename?: 'ActiveSessionType';
  keys: Array<Scalars['String']>;
  session: SkaleSessionType;
};

export type AnnouncementType = Node & {
  __typename?: 'AnnouncementType';
  content: Scalars['String'];
  heading: Scalars['String'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  mode: Scalars['String'];
  organization: OrganizationType;
  timestamp: Scalars['DateTime'];
};

/** A connection to a list of items. */
export type AnnouncementTypeConnection = {
  __typename?: 'AnnouncementTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<AnnouncementTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type AnnouncementTypeEdge = {
  __typename?: 'AnnouncementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: AnnouncementType;
};

export type ApproveKudosRequest = {
  approved: Scalars['Boolean'];
  kudosId: Scalars['GlobalID'];
};

export type ApproveKudosResponse = {
  __typename?: 'ApproveKudosResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export enum CancelReasonEnum {
  ConnectionIssues = 'CONNECTION_ISSUES',
  LeavingQueue = 'LEAVING_QUEUE',
  PartnerCancelled = 'PARTNER_CANCELLED',
  SelfCancelled = 'SELF_CANCELLED',
  TooShort = 'TOO_SHORT'
}

export type ClockedScheduleType = Node & {
  __typename?: 'ClockedScheduleType';
  clockedTime: Scalars['DateTime'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
};

export type CloneHqSkillRequest = {
  skillId: Scalars['GlobalID'];
  targetOrganizationId: Scalars['GlobalID'];
};

export type CloneHqSkillResponse = {
  __typename?: 'CloneHqSkillResponse';
  clonedSkill?: Maybe<SkillType>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CohortType = Node & {
  __typename?: 'CohortType';
  cohortType?: Maybe<Scalars['String']>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  userCount: Scalars['Int'];
  userproxyCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type CohortTypeConnection = {
  __typename?: 'CohortTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<CohortTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CohortTypeEdge = {
  __typename?: 'CohortTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: CohortType;
};

export type CreateAnnouncementMutationRequest = {
  content: Scalars['String'];
  heading: Scalars['String'];
  mode: Scalars['String'];
  timestamp: Scalars['String'];
};

export type CreateAnnouncementMutationResponse = {
  __typename?: 'CreateAnnouncementMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CreateCsvSendEmailRequest = {
  endDate?: InputMaybe<Scalars['String']>;
  exportType: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  summitId?: InputMaybe<Scalars['GlobalID']>;
};

export type CreateCsvSendEmailResponse = {
  __typename?: 'CreateCsvSendEmailResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  recipient: Scalars['String'];
};

export type CreateDiscussionStepType = {
  expectedDurationSeconds: Scalars['Int'];
  id?: InputMaybe<Scalars['GlobalID']>;
  learnerDetail?: Scalars['String'];
  learnerHeading: Scalars['String'];
  teacherDetail?: Scalars['String'];
  teacherHeading: Scalars['String'];
  title: Scalars['String'];
};

export type CreateMemberUserMutationRequest = {
  id: Scalars['GlobalID'];
  organizationId: Scalars['GlobalID'];
};

export type CreateMemberUserMutationResponse = {
  __typename?: 'CreateMemberUserMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CreateOrGetSummitShareLinkMutationRequest = {
  summitId: Scalars['GlobalID'];
};

export type CreateOrGetSummitShareLinkMutationResponse = {
  __typename?: 'CreateOrGetSummitShareLinkMutationResponse';
  inviteUuid?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CreateOrganizationMutationRequest = {
  approvedSessionDuration?: InputMaybe<Scalars['Int']>;
  archiveRatio: Scalars['Int'];
  auth0ConnectionName?: InputMaybe<Scalars['String']>;
  doAgoraForceTcp?: InputMaybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  hasDrivingAlert?: InputMaybe<Scalars['Boolean']>;
  hasTimeClockAlert: Scalars['Boolean'];
  iqmetrixId?: InputMaybe<Scalars['String']>;
  isOpen: Scalars['Boolean'];
  isOpenMaintenance: Scalars['Boolean'];
  isOpenStaff: Scalars['Boolean'];
  isOpenTrainer: Scalars['Boolean'];
  isVendor: Scalars['Boolean'];
  launchDate?: InputMaybe<Scalars['String']>;
  minApprovedSessionDuration?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  orgCode: Scalars['String'];
  orgJoinRule: Scalars['String'];
  shouldSendOnQueueEntry?: InputMaybe<Scalars['Boolean']>;
  showDistrict: Scalars['Boolean'];
  showProprietaryPopup?: InputMaybe<Scalars['Boolean']>;
  showTranscription: Scalars['Boolean'];
  startButtonText: Scalars['String'];
  transcriptionRatio: Scalars['Int'];
};

export type CreateOrganizationMutationResponse = {
  __typename?: 'CreateOrganizationMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CreateQuestionType = {
  id?: InputMaybe<Scalars['GlobalID']>;
  learnerOptions: Scalars['JSON'];
  learnerPrompt: Scalars['String'];
  placementType?: PlacementTypeEnum;
  questionType: QuestionTypeEnum;
  teacherOptions: Scalars['JSON'];
  teacherPrompt: Scalars['String'];
};

export type CreateSkillModuleRequest = {
  canBeReviewed?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPriority?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
};

export type CreateSkillModuleResponse = {
  __typename?: 'CreateSkillModuleResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  skillModule?: Maybe<SkillModuleType>;
};

export type CreateSkillRequest = {
  areRatingsEnabled?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  sessionSteps?: InputMaybe<Scalars['String']>;
  skillModuleId: Scalars['GlobalID'];
  steps?: InputMaybe<Array<CreateStepType>>;
  titleLearner?: InputMaybe<Scalars['String']>;
  titleTeacher?: InputMaybe<Scalars['String']>;
};

export type CreateSkillResponse = {
  __typename?: 'CreateSkillResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  skill?: Maybe<SkillType>;
};

export type CreateStepType = {
  discussionStep?: InputMaybe<CreateDiscussionStepType>;
  question?: InputMaybe<CreateQuestionType>;
};

export type CreateSummitMutationRequest = {
  cohorts?: InputMaybe<Array<Scalars['GlobalID']>>;
  description: Scalars['String'];
  endDate: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  introVideoUrl?: InputMaybe<Scalars['String']>;
  isPublished: Scalars['Boolean'];
  matchAlgorithm: MatchAlgorithmType;
  name: Scalars['String'];
  outroVideoUrl?: InputMaybe<Scalars['String']>;
  skillModuleId?: InputMaybe<Scalars['GlobalID']>;
  skillModules?: InputMaybe<Array<Scalars['GlobalID']>>;
  startDate: Scalars['String'];
};

export type CreateSummitMutationResponse = {
  __typename?: 'CreateSummitMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  summitId?: Maybe<Scalars['GlobalID']>;
};

export type DeactivateTimeWindowRequest = {
  timeWindowId: Scalars['GlobalID'];
};

export type DeactivateTimeWindowResponse = {
  __typename?: 'DeactivateTimeWindowResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeactivateUserFromOrgRequest = {
  userId: Scalars['GlobalID'];
};

export type DeactivateUserFromOrgResponse = {
  __typename?: 'DeactivateUserFromOrgResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeactivateUserResponse = {
  __typename?: 'DeactivateUserResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeclareMatchCancelRequest = {
  cancelledReason?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  skalesessionId?: InputMaybe<Scalars['GlobalID']>;
};

export type DeclareMatchCancelResponse = {
  __typename?: 'DeclareMatchCancelResponse';
  isCancelled?: Maybe<Scalars['Boolean']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeclareMatchEndRequest = {
  duration?: InputMaybe<Scalars['Int']>;
  skalesessionId: Scalars['GlobalID'];
};

export type DeclareMatchEndResponse = {
  __typename?: 'DeclareMatchEndResponse';
  isCancelled?: Maybe<Scalars['Boolean']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeclareMatchReadyRequest = {
  skalesessionId: Scalars['GlobalID'];
};

export type DeclareMatchReadyResponse = {
  __typename?: 'DeclareMatchReadyResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeclareMatchStepReadyRequest = {
  elapsedSeconds: Scalars['Int'];
  skalesessionId: Scalars['GlobalID'];
  step: Scalars['Int'];
  stepElapsedSeconds: Scalars['Int'];
};

export type DeclareMatchStepReadyResponse = {
  __typename?: 'DeclareMatchStepReadyResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DeleteAnnouncementMutationRequest = {
  id: Scalars['GlobalID'];
};

export type DeleteAnnouncementMutationResponse = {
  __typename?: 'DeleteAnnouncementMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type DiscussionStepType = {
  __typename?: 'DiscussionStepType';
  created: Scalars['DateTime'];
  expectedDurationSeconds: Scalars['Int'];
  id: Scalars['GlobalID'];
  learnerDetail: Scalars['String'];
  learnerHeading: Scalars['String'];
  minutes: Scalars['Int'];
  order: Scalars['Int'];
  teacherDetail: Scalars['String'];
  teacherHeading: Scalars['String'];
  title: Scalars['String'];
};

export type DistrictType = Node & {
  __typename?: 'DistrictType';
  activeUserList: UserTypeConnection;
  childrenCompletedQuota?: Maybe<Scalars['Int']>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isActive: Scalars['Boolean'];
  isOnTrack?: Maybe<Scalars['Boolean']>;
  leader?: Maybe<UserType>;
  name: Scalars['String'];
  onTrackChildren?: Maybe<Scalars['Int']>;
  organization: OrganizationType;
  participatingUsers?: Maybe<Scalars['Int']>;
  quotaProgress?: Maybe<Scalars['Int']>;
  quotaTarget?: Maybe<Scalars['Int']>;
  region: RegionType;
  storeCount: Scalars['Int'];
  stores: StoreTypeConnection;
  userCount: Scalars['Int'];
};


export type DistrictTypeActiveUserListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DistrictTypeStoresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type DistrictTypeConnection = {
  __typename?: 'DistrictTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<DistrictTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type DistrictTypeEdge = {
  __typename?: 'DistrictTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: DistrictType;
};

export type EditAnnouncementMutationRequest = {
  content: Scalars['String'];
  heading: Scalars['String'];
  id: Scalars['GlobalID'];
  mode: Scalars['String'];
  timestamp: Scalars['String'];
};

export type EditAnnouncementMutationResponse = {
  __typename?: 'EditAnnouncementMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type EditMemberUserMutationRequest = {
  id: Scalars['GlobalID'];
  internalId?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isCoach?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isStaff?: InputMaybe<Scalars['Boolean']>;
  isTrainer?: InputMaybe<Scalars['Boolean']>;
};

export type EditMemberUserMutationResponse = {
  __typename?: 'EditMemberUserMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type EditOrganizationMutationRequest = {
  approvedSessionDuration?: InputMaybe<Scalars['Int']>;
  archiveRatio?: InputMaybe<Scalars['Int']>;
  auth0ConnectionName?: InputMaybe<Scalars['String']>;
  doAgoraForceTcp?: InputMaybe<Scalars['Boolean']>;
  domain?: InputMaybe<Scalars['String']>;
  hasDrivingAlert?: InputMaybe<Scalars['Boolean']>;
  hasTimeClockAlert?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['GlobalID'];
  iqmetrixId?: InputMaybe<Scalars['String']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  isOpenMaintenance?: InputMaybe<Scalars['Boolean']>;
  isOpenStaff?: InputMaybe<Scalars['Boolean']>;
  isOpenTrainer?: InputMaybe<Scalars['Boolean']>;
  isVendor?: InputMaybe<Scalars['Boolean']>;
  launchDate?: InputMaybe<Scalars['String']>;
  minApprovedSessionDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  orgJoinRule?: InputMaybe<Scalars['String']>;
  shouldSendOnQueueEntry?: InputMaybe<Scalars['Boolean']>;
  showDistrict?: InputMaybe<Scalars['Boolean']>;
  showTranscription?: InputMaybe<Scalars['Boolean']>;
  startButtonText?: InputMaybe<Scalars['String']>;
  transcriptionRatio?: InputMaybe<Scalars['Int']>;
};

export type EditOrganizationMutationResponse = {
  __typename?: 'EditOrganizationMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type EditSkalesessionMutationRequest = {
  allowSharing?: InputMaybe<Scalars['Boolean']>;
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  skalesessionId: Scalars['GlobalID'];
};

export type EditSkalesessionMutationResponse = {
  __typename?: 'EditSkalesessionMutationResponse';
  allowSharing?: Maybe<Scalars['Boolean']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  masteryEdited?: Maybe<Scalars['Boolean']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type EditSkillModuleRequest = {
  canBeReviewed?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPriority?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  skillModuleId: Scalars['GlobalID'];
};

export type EditSkillModuleResponse = {
  __typename?: 'EditSkillModuleResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  skillModule?: Maybe<SkillModuleType>;
};

export type EditSkillRequest = {
  areRatingsEnabled?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  flag?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  ratingsForm?: InputMaybe<Scalars['String']>;
  sessionSteps?: InputMaybe<Scalars['String']>;
  skillId: Scalars['GlobalID'];
  skillModuleId?: InputMaybe<Scalars['GlobalID']>;
  steps?: InputMaybe<Array<CreateStepType>>;
  titleLearner?: InputMaybe<Scalars['String']>;
  titleTeacher?: InputMaybe<Scalars['String']>;
};

export type EditSkillResponse = {
  __typename?: 'EditSkillResponse';
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  skill?: Maybe<SkillType>;
};

export type EditSummitMutationRequest = {
  cohorts?: InputMaybe<Array<Scalars['GlobalID']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introVideoUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  matchAlgorithm?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  outroVideoUrl?: InputMaybe<Scalars['String']>;
  skillModuleId?: InputMaybe<Scalars['GlobalID']>;
  skillModules?: InputMaybe<Array<Scalars['GlobalID']>>;
  startDate?: InputMaybe<Scalars['String']>;
  summitId: Scalars['GlobalID'];
};

export type EditSummitMutationResponse = {
  __typename?: 'EditSummitMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type EditUserPrimaryMutationRequest = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['GlobalID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type EditUserPrimaryMutationResponse = {
  __typename?: 'EditUserPrimaryMutationResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type EditUserRequest = {
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isCoach?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isStaff?: InputMaybe<Scalars['Boolean']>;
  isTrainer?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['GlobalID'];
};

export type EditUserResponse = {
  __typename?: 'EditUserResponse';
  isAdmin?: Maybe<Scalars['Boolean']>;
  isCoach?: Maybe<Scalars['Boolean']>;
  isManager?: Maybe<Scalars['Boolean']>;
  isStaff?: Maybe<Scalars['Boolean']>;
  isTrainer?: Maybe<Scalars['Boolean']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type FeedbackType = Node & {
  __typename?: 'FeedbackType';
  content: Scalars['String'];
  created: Scalars['DateTime'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  resultRating: ResultRatingCategoryType;
  role: Scalars['String'];
  session?: Maybe<SkaleSessionType>;
  sessionUrl: Scalars['String'];
  summit?: Maybe<SummitType>;
  user: UserType;
};

/** A connection to a list of items. */
export type FeedbackTypeConnection = {
  __typename?: 'FeedbackTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<FeedbackTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type FeedbackTypeEdge = {
  __typename?: 'FeedbackTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: FeedbackType;
};

export type GetFeedbackRequest = {
  summitId: Scalars['GlobalID'];
};

export type GetHqMembershipsRequest = {
  userId: Scalars['GlobalID'];
};

export type GetHqOrganizationRequest = {
  organizationId: Scalars['GlobalID'];
};

export type GetHqOrganizationsRequest = {
  searchString: Scalars['String'];
};

export type GetHqSkillRequest = {
  skillId: Scalars['GlobalID'];
};

export type GetHqSkillsRequest = {
  searchString?: InputMaybe<Scalars['String']>;
};

export type GetHqUserRequest = {
  userId: Scalars['GlobalID'];
};

export type GetHqUsersRequest = {
  searchString?: InputMaybe<Scalars['String']>;
};

export type GetKudosRequest = {
  mode: KudosQueryMode;
};

export type GetKudosRequest2 = {
  excludeWithoutMessage?: Scalars['Boolean'];
  includeUnapproved?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<KudosQueryMode>;
  session?: InputMaybe<Scalars['GlobalID']>;
  user?: InputMaybe<Scalars['GlobalID']>;
};

export type GetPrimaryMemberTokenRequest = {
  userId: Scalars['GlobalID'];
};

export type GetSkaleSessionDetailRequest = {
  skalesessionId: Scalars['GlobalID'];
};

export type GetSkillDetailRequest = {
  skillId: Scalars['GlobalID'];
};

export type GetSkillModuleDetailRequest = {
  skillModuleId: Scalars['GlobalID'];
};

export type GetStaffMemberUserListRequest = {
  searchString?: InputMaybe<Scalars['String']>;
};

export type GetStaffSessionListRequest = {
  districtId?: InputMaybe<Scalars['GlobalID']>;
  endDateStr?: InputMaybe<Scalars['String']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  isWithTranscript?: InputMaybe<Scalars['Boolean']>;
  isWithVideo?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['GlobalID']>;
  skillId?: InputMaybe<Scalars['GlobalID']>;
  startDateStr?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['GlobalID']>;
  summitId?: InputMaybe<Scalars['GlobalID']>;
  transcriptSearch?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['GlobalID']>;
};

export type GetStaffSessionSecretRequest = {
  sessionId: Scalars['GlobalID'];
};

export type GetStaffSummitAttendanceListRequest = {
  summitId: Scalars['GlobalID'];
};

export type GetStaffUserInfoRequest = {
  userId: Scalars['GlobalID'];
};

export type GetStaffUserproxiesListRequest = {
  searchString?: InputMaybe<Scalars['String']>;
};

export type GetSummitFeedbackRequest = {
  summitId: Scalars['GlobalID'];
};

export type GetSummitRequest = {
  summitId: Scalars['GlobalID'];
};

export type GetUserDistrictRequest = {
  districtId: Scalars['GlobalID'];
};

export type GetUserRegionRequest = {
  regionId: Scalars['GlobalID'];
};

export type GetUserSessionListRequest = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type GetUserStoreRequest = {
  storeId: Scalars['GlobalID'];
};

export type GetUserSummitSessionListRequest = {
  summitId: Scalars['GlobalID'];
};

export enum GroupType {
  District = 'DISTRICT',
  Region = 'REGION',
  Store = 'STORE'
}

export type HqOrganizationType = Node & {
  __typename?: 'HqOrganizationType';
  ablyChannel: Scalars['String'];
  activeQuota?: Maybe<SessionQuotaType>;
  allowTitleEdit: Scalars['Boolean'];
  approvedSessionDuration: Scalars['Int'];
  archiveRatio: Scalars['Int'];
  auth0ConnectionName?: Maybe<Scalars['String']>;
  cachedFieldsLastUpdated?: Maybe<Scalars['DateTime']>;
  channelName: Scalars['String'];
  childrenCompletedQuota?: Maybe<Scalars['Int']>;
  districtCount: Scalars['Int'];
  doAgoraForceTcp: Scalars['Boolean'];
  domain: Scalars['String'];
  hasDrivingAlert: Scalars['Boolean'];
  hasTimeClockAlert: Scalars['Boolean'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  iqmetrixId?: Maybe<Scalars['String']>;
  isOnTrack?: Maybe<Scalars['Boolean']>;
  isOpen: Scalars['Boolean'];
  isOpenMaintenance: Scalars['Boolean'];
  isOpenStaff: Scalars['Boolean'];
  isOpenTrainer: Scalars['Boolean'];
  isVendor: Scalars['Boolean'];
  launchDate?: Maybe<Scalars['DateTime']>;
  logoUrl: Scalars['String'];
  managerDashboardEnabled: Scalars['Boolean'];
  minApprovedSessionDuration: Scalars['Int'];
  name: Scalars['String'];
  onTrackChildren?: Maybe<Scalars['Int']>;
  orgCode: Scalars['String'];
  orgJoinRule: Scalars['String'];
  orgType: Scalars['String'];
  participatingUsers?: Maybe<Scalars['Int']>;
  quotaProgress?: Maybe<Scalars['Int']>;
  quotaTarget?: Maybe<Scalars['Int']>;
  regionCount: Scalars['Int'];
  regions: RegionTypeConnection;
  rosterCsvUrl: Scalars['String'];
  shouldSendOnQueueEntry: Scalars['Boolean'];
  shouldTriggerCalls: Scalars['Boolean'];
  showDistrict: Scalars['Boolean'];
  showProprietaryPopup: Scalars['Boolean'];
  showTranscription: Scalars['Boolean'];
  startButtonText: Scalars['String'];
  storeCount: Scalars['Int'];
  transcriptionRatio: Scalars['Int'];
  userCount: Scalars['Int'];
  userproxyCount: Scalars['Int'];
};


export type HqOrganizationTypeRegionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type HqOrganizationTypeConnection = {
  __typename?: 'HqOrganizationTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<HqOrganizationTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type HqOrganizationTypeEdge = {
  __typename?: 'HqOrganizationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: HqOrganizationType;
};

export enum IssueCategoryType {
  ContentFailure = 'CONTENT_FAILURE',
  Disconnection = 'DISCONNECTION',
  LowQuality = 'LOW_QUALITY',
  NoPartnerAv = 'NO_PARTNER_AV',
  NoSelfAv = 'NO_SELF_AV',
  Other = 'OTHER',
  ReportPartner = 'REPORT_PARTNER'
}

export type KudosCounts = {
  __typename?: 'KudosCounts';
  friendlyCount: Scalars['Int'];
  goodConversationCount: Scalars['Int'];
  helpfulTipsCount: Scalars['Int'];
  knowledgeableCount: Scalars['Int'];
  receivedCount: Scalars['Int'];
  sentCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum KudosQueryMode {
  All = 'ALL',
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export type KudosType = Node & {
  __typename?: 'KudosType';
  approved?: Maybe<Scalars['Boolean']>;
  categoryFriendly: Scalars['Boolean'];
  categoryGoodConversation: Scalars['Boolean'];
  categoryHelpfulTips: Scalars['Boolean'];
  categoryKnowledgeable: Scalars['Boolean'];
  created: Scalars['DateTime'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  message: Scalars['String'];
  recipient: UserType;
  sender: UserType;
  session?: Maybe<SkaleSessionType>;
};

/** A connection to a list of items. */
export type KudosTypeConnection = {
  __typename?: 'KudosTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<KudosTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type KudosTypeEdge = {
  __typename?: 'KudosTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: KudosType;
};

export type LeaderSummaryType = {
  __typename?: 'LeaderSummaryType';
  id?: Maybe<Scalars['String']>;
  isLeader: Scalars['Boolean'];
  type?: Maybe<GroupType>;
};

export type LoadRosterRequest = {
  deactivateNotOnRoster?: Scalars['Boolean'];
  deactivatePrimaryUsers?: Scalars['Boolean'];
  isDryRun?: Scalars['Boolean'];
  organizationId: Scalars['GlobalID'];
  sendInviteEmails?: Scalars['Boolean'];
  sendReminderEmails?: Scalars['Boolean'];
};

export type LoadRosterResponse = {
  __typename?: 'LoadRosterResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type LogSessionViewRequest = {
  sessionId: Scalars['GlobalID'];
};

export type LogSessionViewResponse = {
  __typename?: 'LogSessionViewResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export enum MatchAlgorithmType {
  NovelLiquid = 'NOVEL_LIQUID',
  NovelLiquidIso = 'NOVEL_LIQUID_ISO',
  NovelLiquidLoc = 'NOVEL_LIQUID_LOC',
  SmallGroup = 'SMALL_GROUP',
  SmallGroupFirstLesson = 'SMALL_GROUP_FIRST_LESSON',
  TrainerRequired = 'TRAINER_REQUIRED'
}

export type MatchQueueType = {
  __typename?: 'MatchQueueType';
  entries: Array<QueueEntryType>;
  organization: OrganizationType;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveKudos: ApproveKudosResponse;
  cloneHqSkill: CloneHqSkillResponse;
  createAnnouncement: CreateAnnouncementMutationResponse;
  createCsvSendEmail: CreateCsvSendEmailResponse;
  createHqMemberUser: CreateMemberUserMutationResponse;
  createHqOrg: CreateOrganizationMutationResponse;
  createOrGetSummitShareLink: CreateOrGetSummitShareLinkMutationResponse;
  createSkill: CreateSkillResponse;
  createSkillModule: CreateSkillModuleResponse;
  createSummit: CreateSummitMutationResponse;
  deactivateTimeWindow: DeactivateTimeWindowResponse;
  deactivateUser: DeactivateUserResponse;
  deactivateUserFromOrg: DeactivateUserFromOrgResponse;
  declareMatchCancel: DeclareMatchCancelResponse;
  declareMatchEnd: DeclareMatchEndResponse;
  declareMatchReady: DeclareMatchReadyResponse;
  declareMatchStepReady: DeclareMatchStepReadyResponse;
  deleteAnnouncement: DeleteAnnouncementMutationResponse;
  editAnnouncement: EditAnnouncementMutationResponse;
  editHqMemberUser: EditMemberUserMutationResponse;
  editHqOrg: EditOrganizationMutationResponse;
  editHqPrimaryUser: EditUserPrimaryMutationResponse;
  editSkalesession: EditSkalesessionMutationResponse;
  editSkill: EditSkillResponse;
  editSkillModule: EditSkillModuleResponse;
  editSummit: EditSummitMutationResponse;
  editUser: EditUserResponse;
  loadRoster: LoadRosterResponse;
  logSessionView: LogSessionViewResponse;
  primaryJoinOrg: PrimaryJoinOrgResponse;
  reportIssue: ReportIssueResponse;
  reportSessionProblem: ReportSessionProblemResponse;
  sendKudos: SendKudosResponse;
  submitAnswers: SubmitAnswersResponse;
  submitFeedback: SubmitFeedbackResponse;
  submitRatings: SubmitRatingsResponse;
  updateTimeWindow: UpdateTimeWindowResponse;
};


export type MutationApproveKudosArgs = {
  approveKudosRequest: ApproveKudosRequest;
};


export type MutationCloneHqSkillArgs = {
  cloneHqSkillRequest: CloneHqSkillRequest;
};


export type MutationCreateAnnouncementArgs = {
  createAnnouncementMutationRequest: CreateAnnouncementMutationRequest;
};


export type MutationCreateCsvSendEmailArgs = {
  createCsvSendEmailRequest: CreateCsvSendEmailRequest;
};


export type MutationCreateHqMemberUserArgs = {
  createMemberUserMutationRequest: CreateMemberUserMutationRequest;
};


export type MutationCreateHqOrgArgs = {
  createOrganizationMutationRequest: CreateOrganizationMutationRequest;
};


export type MutationCreateOrGetSummitShareLinkArgs = {
  createOrGetSummitShareLinkMutationRequest: CreateOrGetSummitShareLinkMutationRequest;
};


export type MutationCreateSkillArgs = {
  createSkillRequest: CreateSkillRequest;
};


export type MutationCreateSkillModuleArgs = {
  createSkillModuleRequest: CreateSkillModuleRequest;
};


export type MutationCreateSummitArgs = {
  createSummitMutationRequest: CreateSummitMutationRequest;
};


export type MutationDeactivateTimeWindowArgs = {
  deactivateTimeWindowRequest: DeactivateTimeWindowRequest;
};


export type MutationDeactivateUserFromOrgArgs = {
  deactivateUserFromOrgRequest: DeactivateUserFromOrgRequest;
};


export type MutationDeclareMatchCancelArgs = {
  declareMatchCancelRequest: DeclareMatchCancelRequest;
};


export type MutationDeclareMatchEndArgs = {
  declareMatchEndRequest: DeclareMatchEndRequest;
};


export type MutationDeclareMatchReadyArgs = {
  declareMatchReadyRequest: DeclareMatchReadyRequest;
};


export type MutationDeclareMatchStepReadyArgs = {
  declareMatchStepReadyRequest: DeclareMatchStepReadyRequest;
};


export type MutationDeleteAnnouncementArgs = {
  deleteAnnouncementMutationRequest: DeleteAnnouncementMutationRequest;
};


export type MutationEditAnnouncementArgs = {
  editAnnouncementMutationRequest: EditAnnouncementMutationRequest;
};


export type MutationEditHqMemberUserArgs = {
  editMemberUserMutationRequest: EditMemberUserMutationRequest;
};


export type MutationEditHqOrgArgs = {
  editOrganizationMutationRequest: EditOrganizationMutationRequest;
};


export type MutationEditHqPrimaryUserArgs = {
  editUserPrimaryRequest: EditUserPrimaryMutationRequest;
};


export type MutationEditSkalesessionArgs = {
  editSkalesessionMutationRequest: EditSkalesessionMutationRequest;
};


export type MutationEditSkillArgs = {
  editSkillRequest: EditSkillRequest;
};


export type MutationEditSkillModuleArgs = {
  editSkillModuleRequest: EditSkillModuleRequest;
};


export type MutationEditSummitArgs = {
  editSummitMutationRequest: EditSummitMutationRequest;
};


export type MutationEditUserArgs = {
  editUserRequest: EditUserRequest;
};


export type MutationLoadRosterArgs = {
  loadRosterRequest: LoadRosterRequest;
};


export type MutationLogSessionViewArgs = {
  logSessionViewRequest: LogSessionViewRequest;
};


export type MutationPrimaryJoinOrgArgs = {
  primaryJoinOrgRequest: PrimaryJoinOrgRequest;
};


export type MutationReportIssueArgs = {
  reportIssueRequest: ReportIssueRequest;
};


export type MutationReportSessionProblemArgs = {
  reportSessionProblemRequest: ReportSessionProblemRequest;
};


export type MutationSendKudosArgs = {
  sendKudosRequest: SendKudosRequest;
};


export type MutationSubmitAnswersArgs = {
  submitAnswersRequest: SubmitAnswersRequest;
};


export type MutationSubmitFeedbackArgs = {
  submitFeedbackRequest: SubmitFeedbackRequest;
};


export type MutationSubmitRatingsArgs = {
  submitRatingsRequest: SubmitRatingsRequest;
};


export type MutationUpdateTimeWindowArgs = {
  updateTimeWindowRequest: UpdateTimeWindowRequest;
};

/** An object with a Globally Unique ID */
export type Node = {
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
};

export type OrganizationType = Node & {
  __typename?: 'OrganizationType';
  ablyChannel: Scalars['String'];
  activeQuota?: Maybe<SessionQuotaType>;
  allowTitleEdit: Scalars['Boolean'];
  approvedSessionDuration: Scalars['Int'];
  archiveRatio: Scalars['Int'];
  auth0ConnectionName?: Maybe<Scalars['String']>;
  cachedFieldsLastUpdated?: Maybe<Scalars['DateTime']>;
  channelName: Scalars['String'];
  childrenCompletedQuota?: Maybe<Scalars['Int']>;
  districtCount: Scalars['Int'];
  doAgoraForceTcp: Scalars['Boolean'];
  domain: Scalars['String'];
  hasDrivingAlert: Scalars['Boolean'];
  hasTimeClockAlert: Scalars['Boolean'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  iqmetrixId?: Maybe<Scalars['String']>;
  isOnTrack?: Maybe<Scalars['Boolean']>;
  isOpen: Scalars['Boolean'];
  isOpenMaintenance: Scalars['Boolean'];
  isOpenStaff: Scalars['Boolean'];
  isOpenTrainer: Scalars['Boolean'];
  isVendor: Scalars['Boolean'];
  launchDate?: Maybe<Scalars['DateTime']>;
  logoUrl: Scalars['String'];
  managerDashboardEnabled: Scalars['Boolean'];
  minApprovedSessionDuration: Scalars['Int'];
  name: Scalars['String'];
  onTrackChildren?: Maybe<Scalars['Int']>;
  orgCode: Scalars['String'];
  orgJoinRule: Scalars['String'];
  orgType: Scalars['String'];
  participatingUsers?: Maybe<Scalars['Int']>;
  quotaProgress?: Maybe<Scalars['Int']>;
  quotaTarget?: Maybe<Scalars['Int']>;
  regionCount: Scalars['Int'];
  regions: RegionTypeConnection;
  shouldSendOnQueueEntry: Scalars['Boolean'];
  shouldTriggerCalls: Scalars['Boolean'];
  showDistrict: Scalars['Boolean'];
  showProprietaryPopup: Scalars['Boolean'];
  showTranscription: Scalars['Boolean'];
  startButtonText: Scalars['String'];
  storeCount: Scalars['Int'];
  transcriptionRatio: Scalars['Int'];
  userCount: Scalars['Int'];
  userproxyCount: Scalars['Int'];
};


export type OrganizationTypeRegionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Information to aid in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PeriodicTaskType = Node & {
  __typename?: 'PeriodicTaskType';
  args: Scalars['JSON'];
  clocked?: Maybe<ClockedScheduleType>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  kwargs: Scalars['JSON'];
  name: Scalars['String'];
  task: Scalars['String'];
};

/** A connection to a list of items. */
export type PeriodicTaskTypeConnection = {
  __typename?: 'PeriodicTaskTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<PeriodicTaskTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PeriodicTaskTypeEdge = {
  __typename?: 'PeriodicTaskTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: PeriodicTaskType;
};

export enum PlacementTypeEnum {
  AfterSession = 'AFTER_SESSION',
  DuringSession = 'DURING_SESSION'
}

export type PrimaryJoinOrgRequest = {
  orgCode: Scalars['String'];
};

export type PrimaryJoinOrgResponse = {
  __typename?: 'PrimaryJoinOrgResponse';
  id?: Maybe<Scalars['GlobalID']>;
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type PublicOrganizationType = Node & {
  __typename?: 'PublicOrganizationType';
  auth0ConnectionName?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isOpen: Scalars['Boolean'];
  name: Scalars['String'];
  orgCode: Scalars['String'];
  orgJoinRule: Scalars['String'];
};

export type PublicUserProxyType = Node & {
  __typename?: 'PublicUserProxyType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  internalId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  userExists: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  activeSessions: Array<ActiveSessionType>;
  cohorts: CohortTypeConnection;
  district?: Maybe<DistrictType>;
  districts: DistrictTypeConnection;
  hqMemberships: UserTypeConnection;
  hqOrganization?: Maybe<HqOrganizationType>;
  hqOrganizations: HqOrganizationTypeConnection;
  hqSkill?: Maybe<SkillType>;
  hqSkills: SkillTypeConnection;
  hqUser?: Maybe<UserType>;
  hqUsers: UserTypeConnection;
  kudos: KudosTypeConnection;
  kudos2: KudosTypeConnection;
  kudosCounts: KudosCounts;
  matchingQueues: Array<MatchQueueType>;
  organization: PublicOrganizationType;
  papertrail: Scalars['String'];
  quotaReport: QuotaReportType;
  region?: Maybe<RegionType>;
  regions: RegionTypeConnection;
  skalesession?: Maybe<SkaleSessionType>;
  skalesessions: SkaleSessionTypeConnection;
  skill?: Maybe<SkillType>;
  skillModule?: Maybe<SkillModuleType>;
  skills: SkillTypeConnection;
  staffAnnouncements: AnnouncementTypeConnection;
  staffCohorts: CohortTypeConnection;
  staffFeedback: FeedbackTypeConnection;
  staffPeriodictasks: PeriodicTaskTypeConnection;
  staffSession?: Maybe<SkaleSessionType>;
  staffSessions: SkaleSessionTypeConnection;
  staffSkillModules: SkillModuleTypeConnection;
  staffSummitFeedback: FeedbackTypeConnection;
  staffSummits: SummitTypeConnection;
  staffUser?: Maybe<UserType>;
  staffUserproxies: UserProxyTypeConnection;
  staffUsers: UserTypeConnection;
  store?: Maybe<StoreType>;
  stores: StoreTypeConnection;
  user: UserType;
  userActiveSummits: SummitTypeConnection;
  userPastSummits: SummitTypeConnection;
  userSessions: SkaleSessionTypeConnection;
  userSummit?: Maybe<SummitType>;
  userproxies: Array<UserProxyType>;
  userproxy: PublicUserProxyType;
  users: UserTypeConnection;
};


export type QueryCohortsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDistrictArgs = {
  getUserDistrictRequest?: InputMaybe<GetUserDistrictRequest>;
};


export type QueryDistrictsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryHqMembershipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getHqMembershipsRequest?: InputMaybe<GetHqMembershipsRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryHqOrganizationArgs = {
  getHqOrganizationRequest?: InputMaybe<GetHqOrganizationRequest>;
};


export type QueryHqOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getHqOrganizationsRequest?: InputMaybe<GetHqOrganizationsRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryHqSkillArgs = {
  getHqSkillRequest?: InputMaybe<GetHqSkillRequest>;
};


export type QueryHqSkillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getHqSkillsRequest?: InputMaybe<GetHqSkillsRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryHqUserArgs = {
  getHqUserRequest?: InputMaybe<GetHqUserRequest>;
};


export type QueryHqUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getHqUsersRequest?: InputMaybe<GetHqUsersRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryKudosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getKudosRequest: GetKudosRequest;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryKudos2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getKudosRequest: GetKudosRequest2;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOrganizationArgs = {
  orgCode: Scalars['String'];
};


export type QueryQuotaReportArgs = {
  userId?: InputMaybe<Scalars['GlobalID']>;
};


export type QueryRegionArgs = {
  getUserRegionRequest?: InputMaybe<GetUserRegionRequest>;
};


export type QueryRegionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySkalesessionArgs = {
  getSkaleSessionDetailRequest?: InputMaybe<GetSkaleSessionDetailRequest>;
};


export type QuerySkalesessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getUserSummitSessionListRequest?: InputMaybe<GetUserSummitSessionListRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySkillArgs = {
  getSkillDetailRequest?: InputMaybe<GetSkillDetailRequest>;
};


export type QuerySkillModuleArgs = {
  getSkillModuleDetailRequest?: InputMaybe<GetSkillModuleDetailRequest>;
};


export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffCohortsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffFeedbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getFeedbackRequest?: InputMaybe<GetFeedbackRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffPeriodictasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffSessionArgs = {
  getStaffSessionSecretRequest?: InputMaybe<GetStaffSessionSecretRequest>;
};


export type QueryStaffSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getStaffSessionListRequest: GetStaffSessionListRequest;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffSkillModulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffSummitFeedbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getSummitFeedbackRequest?: InputMaybe<GetSummitFeedbackRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffSummitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffUserArgs = {
  getStaffUserInfoRequest?: InputMaybe<GetStaffUserInfoRequest>;
};


export type QueryStaffUserproxiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getStaffUserproxiesListRequest?: InputMaybe<GetStaffUserproxiesListRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getStaffMemberUserListRequest?: InputMaybe<GetStaffMemberUserListRequest>;
  getStaffSummitAttendanceListRequest?: InputMaybe<GetStaffSummitAttendanceListRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryStoreArgs = {
  getUserStoreRequest?: InputMaybe<GetUserStoreRequest>;
};


export type QueryStoresArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  getPrimaryMemberTokenRequest?: InputMaybe<GetPrimaryMemberTokenRequest>;
  userId?: InputMaybe<Scalars['GlobalID']>;
};


export type QueryUserActiveSummitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  doIncludeUnpublished?: Scalars['Boolean'];
  first?: InputMaybe<Scalars['Int']>;
  isStaff?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUserPastSummitsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  doIncludeUnpublished?: Scalars['Boolean'];
  first?: InputMaybe<Scalars['Int']>;
  isStaff?: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUserSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  getUserSessionListRequest?: InputMaybe<GetUserSessionListRequest>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUserSummitArgs = {
  getSummitRequest?: InputMaybe<GetSummitRequest>;
};


export type QueryUserproxiesArgs = {
  orgCode: Scalars['String'];
};


export type QueryUserproxyArgs = {
  internalId: Scalars['String'];
  orgCode: Scalars['String'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  primaryMemberUserList?: Scalars['Boolean'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  created: Scalars['DateTime'];
  id: Scalars['GlobalID'];
  learnerOptions: Scalars['JSON'];
  learnerPrompt: Scalars['String'];
  order: Scalars['Int'];
  placementType: PlacementTypeEnum;
  questionType: QuestionTypeEnum;
  teacherOptions: Scalars['JSON'];
  teacherPrompt: Scalars['String'];
};

export enum QuestionTypeEnum {
  Partner = 'PARTNER',
  Self = 'SELF'
}

export type QueueEntryType = {
  __typename?: 'QueueEntryType';
  entryTime: Scalars['DateTime'];
  user: UserType;
};

export type QuotaReportType = {
  __typename?: 'QuotaReportType';
  activeSummitCompletion?: Maybe<SummitCompletionReportType>;
  monthlyCompletedSessions: Scalars['Int'];
  pastSummitCompletion: Array<SummitCompletionReportType>;
  quotaCompletedSessions?: Maybe<Scalars['Int']>;
};

export type RegionType = Node & {
  __typename?: 'RegionType';
  activeUserList: Array<UserType>;
  childrenCompletedQuota?: Maybe<Scalars['Int']>;
  districtCount: Scalars['Int'];
  districts: DistrictTypeConnection;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isActive: Scalars['Boolean'];
  isOnTrack?: Maybe<Scalars['Boolean']>;
  leader?: Maybe<UserType>;
  name: Scalars['String'];
  onTrackChildren?: Maybe<Scalars['Int']>;
  organization: OrganizationType;
  participatingUsers?: Maybe<Scalars['Int']>;
  quotaProgress?: Maybe<Scalars['Int']>;
  quotaTarget?: Maybe<Scalars['Int']>;
  storeCount: Scalars['Int'];
  userCount: Scalars['Int'];
};


export type RegionTypeDistrictsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type RegionTypeConnection = {
  __typename?: 'RegionTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<RegionTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type RegionTypeEdge = {
  __typename?: 'RegionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: RegionType;
};

export type ReportIssueRequest = {
  category?: InputMaybe<IssueCategoryType>;
  content?: InputMaybe<Scalars['String']>;
  skalesessionId?: InputMaybe<Scalars['GlobalID']>;
};

export type ReportIssueResponse = {
  __typename?: 'ReportIssueResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type ReportSessionProblemRequest = {
  reason: Scalars['String'];
  skalesessionId: Scalars['GlobalID'];
};

export type ReportSessionProblemResponse = {
  __typename?: 'ReportSessionProblemResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export enum ResultRatingCategoryType {
  Both = 'BOTH',
  Learned = 'LEARNED',
  Neither = 'NEITHER',
  Taught = 'TAUGHT'
}

export type SendKudosRequest = {
  categoryFriendly?: Scalars['Boolean'];
  categoryGoodConversation?: Scalars['Boolean'];
  categoryHelpfulTips?: Scalars['Boolean'];
  categoryKnowledgeable?: Scalars['Boolean'];
  message: Scalars['String'];
  sessionId: Scalars['GlobalID'];
};

export type SendKudosResponse = {
  __typename?: 'SendKudosResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type SessionQuotaType = Node & {
  __typename?: 'SessionQuotaType';
  endDate: Scalars['DateTime'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  requiredSessionCount: Scalars['Int'];
  startDate: Scalars['DateTime'];
};

export type SkaleSessionType = Node & {
  __typename?: 'SkaleSessionType';
  agoraChannel?: Maybe<Scalars['String']>;
  allowSharing: Scalars['Boolean'];
  answersLearner?: Maybe<Scalars['JSON']>;
  answersTeacher?: Maybe<Scalars['JSON']>;
  archiveId?: Maybe<Scalars['String']>;
  archiveUrl: Scalars['String'];
  cancelledReason?: Maybe<CancelReasonEnum>;
  created: Scalars['DateTime'];
  duration: Scalars['Int'];
  hasLearnerSeenContent: Scalars['Boolean'];
  hasTeacherSeenContent: Scalars['Boolean'];
  hasTranscript: Scalars['Boolean'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isCancelled: Scalars['Boolean'];
  isLearnerReady: Scalars['Boolean'];
  isTeacherReady: Scalars['Boolean'];
  isVendorMatch?: Maybe<Scalars['Boolean']>;
  learner: UserType;
  learnerRating: Scalars['Int'];
  learnerSelfRating: Scalars['Int'];
  learnerSummit?: Maybe<SummitType>;
  masteryEdited: Scalars['Boolean'];
  masteryLevel: Scalars['Int'];
  opentokId?: Maybe<Scalars['String']>;
  organization: OrganizationType;
  ratingsForm?: Maybe<Scalars['JSON']>;
  sessionSteps?: Maybe<Scalars['JSON']>;
  sessionUrl: Scalars['String'];
  skill: SkillType;
  stepsReadyLearner: Array<Scalars['Int']>;
  stepsReadyTeacher: Array<Scalars['Int']>;
  summit?: Maybe<SummitType>;
  teacher: UserType;
  teacherRating: Scalars['Int'];
  teacherSelfRating: Scalars['Int'];
  teacherSummit?: Maybe<SummitType>;
  thumbnailUrl: Scalars['String'];
  transcriptionUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  wordCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type SkaleSessionTypeConnection = {
  __typename?: 'SkaleSessionTypeConnection';
  /** Total count of completed sessions (where is_cancelled=false) */
  completedCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection */
  edges: Array<SkaleSessionTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SkaleSessionTypeEdge = {
  __typename?: 'SkaleSessionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: SkaleSessionType;
};

export type SkillModuleType = Node & {
  __typename?: 'SkillModuleType';
  activeSkillList: SkillTypeConnection;
  canBeReviewed: Scalars['Boolean'];
  description: Scalars['String'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isActive: Scalars['Boolean'];
  isPriority: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parent?: Maybe<SkillModuleType>;
  publishedSkillList: SkillTypeConnection;
};


export type SkillModuleTypeActiveSkillListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SkillModuleTypePublishedSkillListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type SkillModuleTypeConnection = {
  __typename?: 'SkillModuleTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<SkillModuleTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SkillModuleTypeEdge = {
  __typename?: 'SkillModuleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: SkillModuleType;
};

export type SkillType = Node & {
  __typename?: 'SkillType';
  areRatingsEnabled: Scalars['Boolean'];
  description: Scalars['String'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isActive: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  modifiedDate: Scalars['DateTime'];
  name: Scalars['String'];
  order: Scalars['Int'];
  organization: OrganizationType;
  ratingsForm: Scalars['JSONString'];
  sessionSteps: Scalars['JSONString'];
  skillModule: SkillModuleType;
  steps: Array<StepType>;
  suggestedTotalMinutes: Scalars['Int'];
  titleLearner: Scalars['String'];
  titleTeacher: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

/** A connection to a list of items. */
export type SkillTypeConnection = {
  __typename?: 'SkillTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<SkillTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SkillTypeEdge = {
  __typename?: 'SkillTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: SkillType;
};

export type StepType = {
  __typename?: 'StepType';
  discussionStep?: Maybe<DiscussionStepType>;
  question?: Maybe<QuestionType>;
};

export type StoreType = Node & {
  __typename?: 'StoreType';
  activeUserList: Array<UserType>;
  childrenCompletedQuota?: Maybe<Scalars['Int']>;
  district?: Maybe<DistrictType>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  isActive: Scalars['Boolean'];
  isOnTrack?: Maybe<Scalars['Boolean']>;
  leader?: Maybe<UserType>;
  name: Scalars['String'];
  onTrackChildren?: Maybe<Scalars['Int']>;
  organization: OrganizationType;
  participatingUsers?: Maybe<Scalars['Int']>;
  quotaProgress?: Maybe<Scalars['Int']>;
  quotaTarget?: Maybe<Scalars['Int']>;
  region?: Maybe<RegionType>;
  userCount: Scalars['Int'];
  users: UserTypeConnection;
};


export type StoreTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type StoreTypeConnection = {
  __typename?: 'StoreTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<StoreTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type StoreTypeEdge = {
  __typename?: 'StoreTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: StoreType;
};

export type SubmitAnswersRequest = {
  answers?: InputMaybe<Scalars['JSON']>;
  skalesessionId: Scalars['GlobalID'];
};

export type SubmitAnswersResponse = {
  __typename?: 'SubmitAnswersResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type SubmitFeedbackRequest = {
  content?: InputMaybe<Scalars['String']>;
  contentRating?: InputMaybe<Scalars['Int']>;
  qualityRating?: InputMaybe<Scalars['Int']>;
  resultRating?: InputMaybe<ResultRatingCategoryType>;
  role?: InputMaybe<Scalars['String']>;
  skalesessionId?: InputMaybe<Scalars['GlobalID']>;
};

export type SubmitFeedbackResponse = {
  __typename?: 'SubmitFeedbackResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type SubmitRatingsRequest = {
  partnerRating: Scalars['Int'];
  selfRating: Scalars['Int'];
  skalesessionId: Scalars['GlobalID'];
};

export type SubmitRatingsResponse = {
  __typename?: 'SubmitRatingsResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type SummitCompletionReportType = {
  __typename?: 'SummitCompletionReportType';
  completedSkills: Scalars['Int'];
  summit: SummitType;
  totalActiveSkills: Scalars['Int'];
};

export type SummitType = Node & {
  __typename?: 'SummitType';
  cohorts: Array<CohortType>;
  description: Scalars['String'];
  endDate: Scalars['DateTime'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  imageUrl?: Maybe<Scalars['String']>;
  introVideoUrl?: Maybe<Scalars['String']>;
  inviteUuid?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  matchAlgorithm: MatchAlgorithmType;
  name: Scalars['String'];
  organization: OrganizationType;
  outroVideoUrl?: Maybe<Scalars['String']>;
  skillModule?: Maybe<SkillModuleType>;
  skillModules: Array<SkillModuleType>;
  startDate: Scalars['DateTime'];
  timeWindows: TimeWindowTypeConnection;
};


export type SummitTypeTimeWindowsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type SummitTypeConnection = {
  __typename?: 'SummitTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<SummitTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type SummitTypeEdge = {
  __typename?: 'SummitTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: SummitType;
};

export type TimeWindowType = Node & {
  __typename?: 'TimeWindowType';
  endTime: Scalars['Time'];
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  order: Scalars['Int'];
  startTime: Scalars['Time'];
  text: Scalars['String'];
};

/** A connection to a list of items. */
export type TimeWindowTypeConnection = {
  __typename?: 'TimeWindowTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<TimeWindowTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type TimeWindowTypeEdge = {
  __typename?: 'TimeWindowTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: TimeWindowType;
};

export type UpdateTimeWindowRequest = {
  endTime?: InputMaybe<Scalars['Time']>;
  order?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Time']>;
  summitId: Scalars['GlobalID'];
  text?: InputMaybe<Scalars['String']>;
  timeWindowId?: InputMaybe<Scalars['GlobalID']>;
};

export type UpdateTimeWindowResponse = {
  __typename?: 'UpdateTimeWindowResponse';
  ok: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  timeWindowId?: Maybe<Scalars['GlobalID']>;
};

export type UserProxyType = Node & {
  __typename?: 'UserProxyType';
  district?: Maybe<DistrictType>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hireDate?: Maybe<Scalars['Date']>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  internalId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  region?: Maybe<RegionType>;
  store?: Maybe<StoreType>;
  title?: Maybe<Scalars['String']>;
  userExists: Scalars['Boolean'];
};

/** A connection to a list of items. */
export type UserProxyTypeConnection = {
  __typename?: 'UserProxyTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserProxyTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UserProxyTypeEdge = {
  __typename?: 'UserProxyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: UserProxyType;
};

export type UserType = Node & {
  __typename?: 'UserType';
  ablyChannel: Scalars['String'];
  areSessionsAllowed: Scalars['Boolean'];
  channelName: Scalars['String'];
  cohort?: Maybe<CohortType>;
  created: Scalars['DateTime'];
  currMonthScore: Scalars['Int'];
  currMonthSessionCount: Scalars['Int'];
  district?: Maybe<DistrictType>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  hasProfileImgLg: Scalars['Boolean'];
  hasProfileImgSm: Scalars['Boolean'];
  hasSeenTutorial: Scalars['Boolean'];
  hireDate?: Maybe<Scalars['Date']>;
  /** The Globally Unique ID of this object */
  id: Scalars['GlobalID'];
  internalId?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  isClockedIn: Scalars['Boolean'];
  isCoach: Scalars['Boolean'];
  isManager: Scalars['Boolean'];
  isOnTrack?: Maybe<Scalars['Boolean']>;
  isReceivingQueueUpdates: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  isTrainer: Scalars['Boolean'];
  lastActive?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  leaderSummary: LeaderSummaryType;
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  onesignalId?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationType>;
  primaryEmail: Scalars['String'];
  primaryLastLogin?: Maybe<Scalars['DateTime']>;
  profileImgLgUrl: Scalars['String'];
  profileImgSmUrl: Scalars['String'];
  quotaProgress?: Maybe<Scalars['Int']>;
  quotaTarget?: Maybe<Scalars['Int']>;
  region?: Maybe<RegionType>;
  score: Scalars['Int'];
  sessionCount: Scalars['Int'];
  store?: Maybe<StoreType>;
  summitSessionCount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  type: Scalars['String'];
};


export type UserTypeScoreArgs = {
  endDate?: Scalars['String'];
  startDate?: Scalars['String'];
};


export type UserTypeSessionCountArgs = {
  endDate?: Scalars['String'];
  startDate?: Scalars['String'];
};


export type UserTypeSummitSessionCountArgs = {
  summitId?: Scalars['String'];
};

/** A connection to a list of items. */
export type UserTypeConnection = {
  __typename?: 'UserTypeConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserTypeEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
  /** Total quantity of existing nodes. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type UserTypeEdge = {
  __typename?: 'UserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: UserType;
};

export type CreateCsvSendEmailMutationVariables = Exact<{
  createCsvSendEmailRequest: CreateCsvSendEmailRequest;
}>;


export type CreateCsvSendEmailMutation = { __typename?: 'Mutation', createCsvSendEmail: { __typename?: 'CreateCsvSendEmailResponse', ok: boolean, recipient: string, reason?: string | null } };

export type DeactivateUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'DeactivateUserResponse', ok: boolean } };

export type DeactivateUserFromOrgMutationVariables = Exact<{
  deactivateUserFromOrgRequest: DeactivateUserFromOrgRequest;
}>;


export type DeactivateUserFromOrgMutation = { __typename?: 'Mutation', deactivateUserFromOrg: { __typename?: 'DeactivateUserFromOrgResponse', ok: boolean } };

export type DeclareMatchReadyMutationVariables = Exact<{
  declareMatchReadyRequest: DeclareMatchReadyRequest;
}>;


export type DeclareMatchReadyMutation = { __typename?: 'Mutation', declareMatchReady: { __typename?: 'DeclareMatchReadyResponse', ok: boolean } };

export type DeclareMatchStepReadyMutationVariables = Exact<{
  declareMatchStepReadyRequest: DeclareMatchStepReadyRequest;
}>;


export type DeclareMatchStepReadyMutation = { __typename?: 'Mutation', declareMatchStepReady: { __typename?: 'DeclareMatchStepReadyResponse', ok: boolean } };

export type DeclareMatchCancelMutationVariables = Exact<{
  declareMatchCancelRequest: DeclareMatchCancelRequest;
}>;


export type DeclareMatchCancelMutation = { __typename?: 'Mutation', declareMatchCancel: { __typename?: 'DeclareMatchCancelResponse', ok: boolean } };

export type DeclareMatchEndMutationVariables = Exact<{
  declareMatchEndRequest: DeclareMatchEndRequest;
}>;


export type DeclareMatchEndMutation = { __typename?: 'Mutation', declareMatchEnd: { __typename?: 'DeclareMatchEndResponse', ok: boolean, reason?: string | null, isCancelled?: boolean | null } };

export type SubmitFeedbackMutationVariables = Exact<{
  submitFeedbackRequest: SubmitFeedbackRequest;
}>;


export type SubmitFeedbackMutation = { __typename?: 'Mutation', submitFeedback: { __typename?: 'SubmitFeedbackResponse', ok: boolean, reason?: string | null } };

export type SubmitAnswersMutationVariables = Exact<{
  submitAnswersRequest: SubmitAnswersRequest;
}>;


export type SubmitAnswersMutation = { __typename?: 'Mutation', submitAnswers: { __typename?: 'SubmitAnswersResponse', ok: boolean, reason?: string | null } };

export type ReportIssueMutationVariables = Exact<{
  reportIssueRequest: ReportIssueRequest;
}>;


export type ReportIssueMutation = { __typename?: 'Mutation', reportIssue: { __typename?: 'ReportIssueResponse', ok: boolean, reason?: string | null } };

export type ReportSessionProblemMutationVariables = Exact<{
  reportSessionProblemRequest: ReportSessionProblemRequest;
}>;


export type ReportSessionProblemMutation = { __typename?: 'Mutation', reportSessionProblem: { __typename?: 'ReportSessionProblemResponse', ok: boolean, reason?: string | null } };

export type EditSummitMutationVariables = Exact<{
  editSummitMutationRequest: EditSummitMutationRequest;
}>;


export type EditSummitMutation = { __typename?: 'Mutation', editSummit: { __typename?: 'EditSummitMutationResponse', ok: boolean, reason?: string | null } };

export type CreateSummitMutationVariables = Exact<{
  createSummitMutationRequest: CreateSummitMutationRequest;
}>;


export type CreateSummitMutation = { __typename?: 'Mutation', createSummit: { __typename?: 'CreateSummitMutationResponse', ok: boolean, reason?: string | null, summitId?: string | null } };

export type CreateOrGetSummitShareLinkMutationVariables = Exact<{
  createOrGetSummitShareLinkMutationRequest: CreateOrGetSummitShareLinkMutationRequest;
}>;


export type CreateOrGetSummitShareLinkMutation = { __typename?: 'Mutation', createOrGetSummitShareLink: { __typename?: 'CreateOrGetSummitShareLinkMutationResponse', ok: boolean, reason?: string | null, inviteUuid?: string | null } };

export type EditSkalesessionMutationVariables = Exact<{
  editSkalesessionMutationRequest: EditSkalesessionMutationRequest;
}>;


export type EditSkalesessionMutation = { __typename?: 'Mutation', editSkalesession: { __typename?: 'EditSkalesessionMutationResponse', ok: boolean, reason?: string | null, isCancelled?: boolean | null, allowSharing?: boolean | null, masteryEdited?: boolean | null } };

export type CreateAnnouncementMutationVariables = Exact<{
  createAnnouncementMutationRequest: CreateAnnouncementMutationRequest;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: { __typename?: 'CreateAnnouncementMutationResponse', ok: boolean, reason?: string | null } };

export type EditAnnouncementMutationVariables = Exact<{
  editAnnouncementMutationRequest: EditAnnouncementMutationRequest;
}>;


export type EditAnnouncementMutation = { __typename?: 'Mutation', editAnnouncement: { __typename?: 'EditAnnouncementMutationResponse', ok: boolean, reason?: string | null } };

export type DeleteAnnouncementMutationVariables = Exact<{
  deleteAnnouncementMutationRequest: DeleteAnnouncementMutationRequest;
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', deleteAnnouncement: { __typename?: 'DeleteAnnouncementMutationResponse', ok: boolean, reason?: string | null } };

export type PrimaryJoinOrgMutationVariables = Exact<{
  primaryJoinOrgRequest: PrimaryJoinOrgRequest;
}>;


export type PrimaryJoinOrgMutation = { __typename?: 'Mutation', primaryJoinOrg: { __typename?: 'PrimaryJoinOrgResponse', ok: boolean, id?: string | null, reason?: string | null } };

export type EditSkillModuleMutationVariables = Exact<{
  editSkillModuleRequest: EditSkillModuleRequest;
}>;


export type EditSkillModuleMutation = { __typename?: 'Mutation', editSkillModule: { __typename?: 'EditSkillModuleResponse', ok: boolean, reason?: string | null, skillModule?: { __typename?: 'SkillModuleType', id: string, name: string, order: number, description: string, isActive: boolean, canBeReviewed: boolean, activeSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, isPublished: boolean, isActive: boolean, areRatingsEnabled: boolean } }> } } | null } };

export type EditSkillMutationVariables = Exact<{
  editSkillRequest: EditSkillRequest;
}>;


export type EditSkillMutation = { __typename?: 'Mutation', editSkill: { __typename?: 'EditSkillResponse', ok: boolean, reason?: string | null, message?: string | null, skill?: { __typename?: 'SkillType', id: string, name: string, order: number, description: string, isActive: boolean, isPublished: boolean, areRatingsEnabled: boolean } | null } };

export type CreateSkillModuleMutationVariables = Exact<{
  createSkillModuleRequest: CreateSkillModuleRequest;
}>;


export type CreateSkillModuleMutation = { __typename?: 'Mutation', createSkillModule: { __typename?: 'CreateSkillModuleResponse', ok: boolean, reason?: string | null, skillModule?: { __typename?: 'SkillModuleType', id: string, name: string, order: number, description: string, isActive: boolean, canBeReviewed: boolean } | null } };

export type CreateSkillMutationVariables = Exact<{
  createSkillRequest: CreateSkillRequest;
}>;


export type CreateSkillMutation = { __typename?: 'Mutation', createSkill: { __typename?: 'CreateSkillResponse', ok: boolean, reason?: string | null, skill?: { __typename?: 'SkillType', id: string, name: string, order: number, description: string, isActive: boolean, isPublished: boolean, areRatingsEnabled: boolean } | null } };

export type EditUserMutationVariables = Exact<{
  editUserRequest: EditUserRequest;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser: { __typename?: 'EditUserResponse', ok: boolean, reason?: string | null, isAdmin?: boolean | null, isStaff?: boolean | null, isManager?: boolean | null, isTrainer?: boolean | null, isCoach?: boolean | null } };

export type UpdateTimeWindowMutationVariables = Exact<{
  updateTimeWindowRequest: UpdateTimeWindowRequest;
}>;


export type UpdateTimeWindowMutation = { __typename?: 'Mutation', updateTimeWindow: { __typename?: 'UpdateTimeWindowResponse', ok: boolean, reason?: string | null, timeWindowId?: string | null } };

export type DeactivateTimeWindowMutationVariables = Exact<{
  deactivateTimeWindowRequest: DeactivateTimeWindowRequest;
}>;


export type DeactivateTimeWindowMutation = { __typename?: 'Mutation', deactivateTimeWindow: { __typename?: 'DeactivateTimeWindowResponse', ok: boolean, reason?: string | null } };

export type ApproveKudosMutationVariables = Exact<{
  approveKudosRequest: ApproveKudosRequest;
}>;


export type ApproveKudosMutation = { __typename?: 'Mutation', approveKudos: { __typename?: 'ApproveKudosResponse', ok: boolean, reason?: string | null } };

export type LogSessionViewMutationVariables = Exact<{
  logSessionViewRequest: LogSessionViewRequest;
}>;


export type LogSessionViewMutation = { __typename?: 'Mutation', logSessionView: { __typename?: 'LogSessionViewResponse', ok: boolean, reason?: string | null } };

export type SendKudosMutationVariables = Exact<{
  sendKudosRequest: SendKudosRequest;
}>;


export type SendKudosMutation = { __typename?: 'Mutation', sendKudos: { __typename?: 'SendKudosResponse', ok: boolean, reason?: string | null } };

export type GetDistrictLeaderboardQueryVariables = Exact<{
  getUserDistrictRequest?: InputMaybe<GetUserDistrictRequest>;
}>;


export type GetDistrictLeaderboardQuery = { __typename?: 'Query', district?: { __typename?: 'DistrictType', name: string, isActive: boolean, storeCount: number, userCount: number, organization: { __typename?: 'OrganizationType', name: string }, activeUserList: { __typename?: 'UserTypeConnection', edges: Array<{ __typename?: 'UserTypeEdge', node: { __typename?: 'UserType', id: string, firstName: string, lastName: string, primaryEmail: string, title?: string | null, profileImgLgUrl: string, profileImgSmUrl: string, currMonthSessionCount: number, isActive: boolean } }> } } | null };

export type GetUserRegionInfoQueryVariables = Exact<{
  getUserRegionRequest: GetUserRegionRequest;
}>;


export type GetUserRegionInfoQuery = { __typename?: 'Query', region?: { __typename?: 'RegionType', id: string, name: string, districtCount: number, storeCount: number, userCount: number } | null };

export type GetUserDistrictInfoQueryVariables = Exact<{
  getUserDistrictRequest: GetUserDistrictRequest;
}>;


export type GetUserDistrictInfoQuery = { __typename?: 'Query', district?: { __typename?: 'DistrictType', id: string, name: string, storeCount: number, userCount: number, region: { __typename?: 'RegionType', id: string, name: string } } | null };

export type GetUserStoreInfoQueryVariables = Exact<{
  getUserStoreRequest: GetUserStoreRequest;
}>;


export type GetUserStoreInfoQuery = { __typename?: 'Query', store?: { __typename?: 'StoreType', id: string, name: string, userCount: number, region?: { __typename?: 'RegionType', id: string, name: string } | null, district?: { __typename?: 'DistrictType', id: string, name: string } | null } | null };

export type GetStoreListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoreListQuery = { __typename?: 'Query', stores: { __typename?: 'StoreTypeConnection', edges: Array<{ __typename?: 'StoreTypeEdge', node: { __typename?: 'StoreType', id: string, name: string } }> } };

export type GetRegionListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionListQuery = { __typename?: 'Query', regions: { __typename?: 'RegionTypeConnection', edges: Array<{ __typename?: 'RegionTypeEdge', node: { __typename?: 'RegionType', id: string, name: string } }> } };

export type GetDistrictListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDistrictListQuery = { __typename?: 'Query', districts: { __typename?: 'DistrictTypeConnection', edges: Array<{ __typename?: 'DistrictTypeEdge', node: { __typename?: 'DistrictType', id: string, name: string } }> } };

export type GetSkillListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillListQuery = { __typename?: 'Query', skills: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, name: string, isPublished: boolean, isActive: boolean } }> } };

export type OrganizationQueryVariables = Exact<{
  orgCode: Scalars['String'];
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'PublicOrganizationType', name: string, orgCode: string, orgJoinRule: string, auth0ConnectionName?: string | null, isOpen: boolean } };

export type UserproxyQueryVariables = Exact<{
  internalId: Scalars['String'];
  orgCode: Scalars['String'];
}>;


export type UserproxyQuery = { __typename?: 'Query', userproxy: { __typename?: 'PublicUserProxyType', internalId?: string | null, email?: string | null, title?: string | null, name: string, firstName?: string | null, lastName?: string | null, userExists: boolean } };

export type GetPrimaryMemberListQueryVariables = Exact<{
  primaryMemberUserList: Scalars['Boolean'];
}>;


export type GetPrimaryMemberListQuery = { __typename?: 'Query', users: { __typename?: 'UserTypeConnection', edges: Array<{ __typename?: 'UserTypeEdge', node: { __typename?: 'UserType', id: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, orgCode: string } | null } }> } };

export type GetMemberUserListQueryVariables = Exact<{
  getStaffMemberUserListRequest?: InputMaybe<GetStaffMemberUserListRequest>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberUserListQuery = { __typename?: 'Query', staffUsers: { __typename?: 'UserTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'UserTypeEdge', node: { __typename?: 'UserType', id: string, firstName: string, lastName: string, title?: string | null, internalId?: string | null, primaryEmail: string, hireDate?: string | null, created: string, primaryLastLogin?: string | null, lastActive?: string | null, isAdmin: boolean, isStaff: boolean, isManager: boolean, isTrainer: boolean, isCoach: boolean, profileImgSmUrl: string, region?: { __typename?: 'RegionType', id: string, name: string } | null, district?: { __typename?: 'DistrictType', id: string, name: string } | null, store?: { __typename?: 'StoreType', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetMemberUserSearchListQueryVariables = Exact<{
  getStaffMemberUserListRequest?: InputMaybe<GetStaffMemberUserListRequest>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberUserSearchListQuery = { __typename?: 'Query', staffUsers: { __typename?: 'UserTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'UserTypeEdge', node: { __typename?: 'UserType', id: string, firstName: string, lastName: string, primaryEmail: string } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetUserproxiesListQueryVariables = Exact<{
  getStaffUserproxiesListRequest?: InputMaybe<GetStaffUserproxiesListRequest>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetUserproxiesListQuery = { __typename?: 'Query', staffUserproxies: { __typename?: 'UserProxyTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'UserProxyTypeEdge', node: { __typename?: 'UserProxyType', email?: string | null, hireDate?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, internalId?: string | null, region?: { __typename?: 'RegionType', name: string } | null, district?: { __typename?: 'DistrictType', name: string } | null, store?: { __typename?: 'StoreType', name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetSessionListQueryVariables = Exact<{
  getStaffSessionListRequest: GetStaffSessionListRequest;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetSessionListQuery = { __typename?: 'Query', staffSessions: { __typename?: 'SkaleSessionTypeConnection', totalCount?: number | null, completedCount?: number | null, edges: Array<{ __typename?: 'SkaleSessionTypeEdge', node: { __typename?: 'SkaleSessionType', id: string, created: string, duration: number, archiveUrl: string, isCancelled: boolean, thumbnailUrl: string, teacherRating: number, teacherSelfRating: number, learnerRating: number, learnerSelfRating: number, transcriptionUrl: string, hasTranscript: boolean, teacherSummit?: { __typename?: 'SummitType', name: string } | null, learnerSummit?: { __typename?: 'SummitType', name: string } | null, skill: { __typename?: 'SkillType', id: string, name: string, titleTeacher: string, titleLearner: string }, learner: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, title?: string | null, store?: { __typename?: 'StoreType', name: string } | null, cohort?: { __typename?: 'CohortType', name: string } | null }, teacher: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, title?: string | null, store?: { __typename?: 'StoreType', name: string } | null, cohort?: { __typename?: 'CohortType', name: string } | null } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetUserSessionListQueryVariables = Exact<{
  first: Scalars['Int'];
  getUserSessionListRequest?: InputMaybe<GetUserSessionListRequest>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetUserSessionListQuery = { __typename?: 'Query', userSessions: { __typename?: 'SkaleSessionTypeConnection', completedCount?: number | null, edges: Array<{ __typename?: 'SkaleSessionTypeEdge', node: { __typename?: 'SkaleSessionType', id: string, created: string, duration: number, isCancelled: boolean, cancelledReason?: CancelReasonEnum | null, thumbnailUrl: string, skill: { __typename?: 'SkillType', id: string, name: string }, learner: { __typename?: 'UserType', id: string, firstName: string, lastName: string, title?: string | null, profileImgLgUrl: string, profileImgSmUrl: string }, teacher: { __typename?: 'UserType', id: string, firstName: string, lastName: string, title?: string | null, profileImgLgUrl: string, profileImgSmUrl: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetStaffSessionSecretQueryVariables = Exact<{
  getStaffSessionSecretRequest: GetStaffSessionSecretRequest;
}>;


export type GetStaffSessionSecretQuery = { __typename?: 'Query', staffSession?: { __typename?: 'SkaleSessionType', id: string, created: string, teacherRating: number, teacherSelfRating: number, learnerRating: number, learnerSelfRating: number, masteryLevel: number, masteryEdited: boolean, allowSharing: boolean, sessionSteps?: any | null, stepsReadyTeacher: Array<number>, stepsReadyLearner: Array<number>, archiveUrl: string, transcriptionUrl: string, hasTranscript: boolean, isCancelled: boolean, organization: { __typename?: 'OrganizationType', id: string, name: string, showProprietaryPopup: boolean }, teacher: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email?: string | null, profileImgSmUrl: string, title?: string | null, store?: { __typename?: 'StoreType', name: string } | null }, learner: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email?: string | null, profileImgSmUrl: string, title?: string | null, store?: { __typename?: 'StoreType', name: string } | null }, skill: { __typename?: 'SkillType', name: string, titleTeacher: string, titleLearner: string } } | null };

export type GetStaffUserInfoQueryVariables = Exact<{
  getStaffUserInfoRequest: GetStaffUserInfoRequest;
}>;


export type GetStaffUserInfoQuery = { __typename?: 'Query', staffUser?: { __typename?: 'UserType', id: string, primaryEmail: string, firstName: string, lastName: string, profileImgSmUrl: string, profileImgLgUrl: string, score: number, sessionCount: number, hasSeenTutorial: boolean, title?: string | null, region?: { __typename?: 'RegionType', id: string, name: string } | null, district?: { __typename?: 'DistrictType', id: string, name: string } | null, store?: { __typename?: 'StoreType', id: string, name: string, leader?: { __typename?: 'UserType', firstName: string, lastName: string, profileImgSmUrl: string } | null } | null } | null };

export type GetSkillDetailQueryVariables = Exact<{
  getSkillDetailRequest: GetSkillDetailRequest;
}>;


export type GetSkillDetailQuery = { __typename?: 'Query', skill?: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, titleTeacher: string, titleLearner: string, sessionSteps: any, videoUrl?: string | null, isPublished: boolean, isActive: boolean, suggestedTotalMinutes: number, skillModule: { __typename?: 'SkillModuleType', id: string, order: number, name: string } } | null };

export type GetMePrimaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMePrimaryQuery = { __typename?: 'Query', user: { __typename?: 'UserType', id: string, email?: string | null, firstName: string, lastName: string } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', user: { __typename?: 'UserType', id: string, primaryEmail: string, firstName: string, lastName: string, channelName: string, profileImgSmUrl: string, profileImgLgUrl: string, score: number, hasSeenTutorial: boolean, isAdmin: boolean, isManager: boolean, isStaff: boolean, isTrainer: boolean, isCoach: boolean, title?: string | null, isReceivingQueueUpdates: boolean, type: string, onesignalId?: string | null, organization?: { __typename?: 'OrganizationType', id: string, name: string, domain: string, orgCode: string, isOpen: boolean, isOpenStaff: boolean, isOpenTrainer: boolean, isOpenMaintenance: boolean, hasTimeClockAlert: boolean, logoUrl: string, showDistrict: boolean, showTranscription: boolean, archiveRatio: number, startButtonText: string, launchDate?: string | null, allowTitleEdit: boolean, orgType: string, auth0ConnectionName?: string | null, doAgoraForceTcp: boolean, channelName: string, managerDashboardEnabled: boolean, cachedFieldsLastUpdated?: string | null, userCount: number, userproxyCount: number, activeQuota?: { __typename?: 'SessionQuotaType', startDate: string, endDate: string, requiredSessionCount: number } | null } | null, region?: { __typename?: 'RegionType', id: string } | null, district?: { __typename?: 'DistrictType', id: string } | null, store?: { __typename?: 'StoreType', id: string, name: string } | null, leaderSummary: { __typename?: 'LeaderSummaryType', id?: string | null, isLeader: boolean, type?: GroupType | null } } };

export type GetPrimaryMemberTokenQueryVariables = Exact<{
  getPrimaryMemberTokenRequest?: InputMaybe<GetPrimaryMemberTokenRequest>;
}>;


export type GetPrimaryMemberTokenQuery = { __typename?: 'Query', user: { __typename?: 'UserType', token: string } };

export type GetSkaleSessionQueryVariables = Exact<{
  getSkaleSessionDetailRequest: GetSkaleSessionDetailRequest;
}>;


export type GetSkaleSessionQuery = { __typename?: 'Query', skalesession?: { __typename?: 'SkaleSessionType', id: string, isTeacherReady: boolean, isLearnerReady: boolean, hasTeacherSeenContent: boolean, hasLearnerSeenContent: boolean, stepsReadyTeacher: Array<number>, stepsReadyLearner: Array<number>, isVendorMatch?: boolean | null, agoraChannel?: string | null, summit?: { __typename?: 'SummitType', id: string } | null, teacher: { __typename?: 'UserType', id: string, firstName: string, lastName: string, title?: string | null, profileImgSmUrl: string, profileImgLgUrl: string, organization?: { __typename?: 'OrganizationType', name: string } | null, district?: { __typename?: 'DistrictType', name: string } | null }, learner: { __typename?: 'UserType', id: string, firstName: string, lastName: string, title?: string | null, profileImgSmUrl: string, profileImgLgUrl: string, organization?: { __typename?: 'OrganizationType', name: string } | null, district?: { __typename?: 'DistrictType', name: string } | null }, skill: { __typename?: 'SkillType', id: string, name: string, titleTeacher: string, titleLearner: string, description: string, sessionSteps: any, suggestedTotalMinutes: number } } | null };

export type GetSummitDetailQueryVariables = Exact<{
  getSummitRequest: GetSummitRequest;
}>;


export type GetSummitDetailQuery = { __typename?: 'Query', userSummit?: { __typename?: 'SummitType', id: string, isPublished: boolean, name: string, inviteUuid?: string | null, description: string, startDate: string, endDate: string, imageUrl?: string | null, introVideoUrl?: string | null, matchAlgorithm: MatchAlgorithmType, skillModules: Array<{ __typename?: 'SkillModuleType', id: string, order: number, name: string, isActive: boolean, activeSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, titleTeacher: string, titleLearner: string, sessionSteps: any, videoUrl?: string | null, isPublished: boolean, isActive: boolean, suggestedTotalMinutes: number, skillModule: { __typename?: 'SkillModuleType', id: string, order: number, name: string } } }> }, publishedSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, titleTeacher: string, titleLearner: string, sessionSteps: any, videoUrl?: string | null, isPublished: boolean, isActive: boolean, suggestedTotalMinutes: number, skillModule: { __typename?: 'SkillModuleType', id: string, order: number, name: string } } }> } }>, cohorts: Array<{ __typename?: 'CohortType', id: string, name: string, cohortType?: string | null }>, organization: { __typename?: 'OrganizationType', domain: string, orgCode: string, name: string }, timeWindows: { __typename?: 'TimeWindowTypeConnection', edges: Array<{ __typename?: 'TimeWindowTypeEdge', node: { __typename?: 'TimeWindowType', id: string, startTime: any, endTime: any, text: string, order: number } }> } } | null };

export type GetUserSessionListQuotaCompletionQueryVariables = Exact<{
  getUserSessionListRequest?: InputMaybe<GetUserSessionListRequest>;
}>;


export type GetUserSessionListQuotaCompletionQuery = { __typename?: 'Query', userSessions: { __typename?: 'SkaleSessionTypeConnection', completedCount?: number | null } };

export type GetStaffSummitListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffSummitListQuery = { __typename?: 'Query', staffSummits: { __typename?: 'SummitTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, isPublished: boolean, name: string, inviteUuid?: string | null, description: string, startDate: string, endDate: string, imageUrl?: string | null, introVideoUrl?: string | null, matchAlgorithm: MatchAlgorithmType, skillModules: Array<{ __typename?: 'SkillModuleType', id: string, order: number, name: string, isActive: boolean, activeSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, titleTeacher: string, titleLearner: string, sessionSteps: any, videoUrl?: string | null, isPublished: boolean, isActive: boolean, suggestedTotalMinutes: number, skillModule: { __typename?: 'SkillModuleType', id: string, order: number, name: string } } }> }, publishedSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, titleTeacher: string, titleLearner: string, sessionSteps: any, videoUrl?: string | null, isPublished: boolean, isActive: boolean, suggestedTotalMinutes: number, skillModule: { __typename?: 'SkillModuleType', id: string, order: number, name: string } } }> } }>, organization: { __typename?: 'OrganizationType', domain: string, orgCode: string, name: string } } }> } };

export type GetUserSummitSessionListQueryVariables = Exact<{
  getUserSummitSessionListRequest?: InputMaybe<GetUserSummitSessionListRequest>;
}>;


export type GetUserSummitSessionListQuery = { __typename?: 'Query', skalesessions: { __typename?: 'SkaleSessionTypeConnection', edges: Array<{ __typename?: 'SkaleSessionTypeEdge', node: { __typename?: 'SkaleSessionType', id: string, created: string, isCancelled: boolean, learner: { __typename?: 'UserType', id: string, firstName: string, lastName: string }, teacher: { __typename?: 'UserType', id: string, firstName: string, lastName: string }, skill: { __typename?: 'SkillType', id: string, name: string, suggestedTotalMinutes: number, isPublished: boolean } } }> } };

export type SummitRouteGetSkillDetailQueryVariables = Exact<{
  getSkillDetailRequest: GetSkillDetailRequest;
}>;


export type SummitRouteGetSkillDetailQuery = { __typename?: 'Query', skill?: { __typename?: 'SkillType', description: string, isPublished: boolean } | null };

export type GetCurriculumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurriculumQuery = { __typename?: 'Query', staffSkillModules: { __typename?: 'SkillModuleTypeConnection', edges: Array<{ __typename?: 'SkillModuleTypeEdge', node: { __typename?: 'SkillModuleType', id: string, order: number, name: string, description: string, isActive: boolean, publishedSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, titleTeacher: string } }> } } }> } };

export type GetCohortsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCohortsQuery = { __typename?: 'Query', staffCohorts: { __typename?: 'CohortTypeConnection', edges: Array<{ __typename?: 'CohortTypeEdge', node: { __typename?: 'CohortType', id: string, name: string, cohortType?: string | null } }> } };

export type GetSummitFeedbackListQueryVariables = Exact<{
  getSummitFeedbackRequest: GetSummitFeedbackRequest;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetSummitFeedbackListQuery = { __typename?: 'Query', staffSummitFeedback: { __typename?: 'FeedbackTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'FeedbackTypeEdge', node: { __typename?: 'FeedbackType', id: string, created: string, content: string, role: string, session?: { __typename?: 'SkaleSessionType', id: string, thumbnailUrl: string, archiveUrl: string, duration: number } | null, summit?: { __typename?: 'SummitType', id: string, name: string } | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, primaryEmail: string } } }> } };

export type GetSummitAttendanceListQueryVariables = Exact<{
  getStaffSummitAttendanceListRequest: GetStaffSummitAttendanceListRequest;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetSummitAttendanceListQuery = { __typename?: 'Query', staffUsers: { __typename?: 'UserTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'UserTypeEdge', node: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, summitSessionCount: number, title?: string | null, primaryEmail: string, isTrainer: boolean } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetStaffPeriodicTaskListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffPeriodicTaskListQuery = { __typename?: 'Query', staffPeriodictasks: { __typename?: 'PeriodicTaskTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PeriodicTaskTypeEdge', node: { __typename?: 'PeriodicTaskType', id: string, kwargs: any, clocked?: { __typename?: 'ClockedScheduleType', clockedTime: string } | null } }> } };

export type GetCurriculumListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurriculumListQuery = { __typename?: 'Query', staffSkillModules: { __typename?: 'SkillModuleTypeConnection', edges: Array<{ __typename?: 'SkillModuleTypeEdge', node: { __typename?: 'SkillModuleType', id: string, order: number, name: string, description: string, isActive: boolean, canBeReviewed: boolean, activeSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string, description: string, isPublished: boolean, isActive: boolean } }> } } }> } };

export type GetSkillModuleDetailQueryVariables = Exact<{
  getSkillModuleDetailRequest: GetSkillModuleDetailRequest;
}>;


export type GetSkillModuleDetailQuery = { __typename?: 'Query', skillModule?: { __typename?: 'SkillModuleType', id: string, order: number, name: string, description: string, isActive: boolean, canBeReviewed: boolean } | null };

export type GetActiveSummitListQueryVariables = Exact<{
  isStaff?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetActiveSummitListQuery = { __typename?: 'Query', userActiveSummits: { __typename?: 'SummitTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, name: string, startDate: string, endDate: string, imageUrl?: string | null, introVideoUrl?: string | null, description: string, skillModules: Array<{ __typename?: 'SkillModuleType', id: string }>, timeWindows: { __typename?: 'TimeWindowTypeConnection', edges: Array<{ __typename?: 'TimeWindowTypeEdge', node: { __typename?: 'TimeWindowType', id: string, startTime: any, endTime: any, text: string, order: number } }> } } }> } };

export type GetActiveSummitCurriculumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSummitCurriculumQuery = { __typename?: 'Query', userActiveSummits: { __typename?: 'SummitTypeConnection', edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, name: string, startDate: string, endDate: string, skillModules: Array<{ __typename?: 'SkillModuleType', id: string, order: number, name: string, publishedSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string } }> } }> } }> } };

export type GetPastSummitCurriculumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPastSummitCurriculumQuery = { __typename?: 'Query', userPastSummits: { __typename?: 'SummitTypeConnection', edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, name: string, startDate: string, endDate: string, skillModules: Array<{ __typename?: 'SkillModuleType', id: string, order: number, name: string, publishedSkillList: { __typename?: 'SkillTypeConnection', edges: Array<{ __typename?: 'SkillTypeEdge', node: { __typename?: 'SkillType', id: string, order: number, name: string } }> } }> } }> } };

export type GetStaffActiveSummitListQueryVariables = Exact<{
  isStaff?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetStaffActiveSummitListQuery = { __typename?: 'Query', userActiveSummits: { __typename?: 'SummitTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, name: string, startDate: string, endDate: string, imageUrl?: string | null, isPublished: boolean, introVideoUrl?: string | null, description: string, matchAlgorithm: MatchAlgorithmType, skillModules: Array<{ __typename?: 'SkillModuleType', id: string }>, cohorts: Array<{ __typename?: 'CohortType', id: string, name: string, cohortType?: string | null, userCount: number, userproxyCount: number }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPastSummitListQueryVariables = Exact<{
  isStaff?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetPastSummitListQuery = { __typename?: 'Query', userPastSummits: { __typename?: 'SummitTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, name: string, startDate: string, endDate: string, imageUrl?: string | null, isPublished: boolean, introVideoUrl?: string | null, description: string, skillModules: Array<{ __typename?: 'SkillModuleType', id: string }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetStaffPastSummitListQueryVariables = Exact<{
  isStaff?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetStaffPastSummitListQuery = { __typename?: 'Query', userPastSummits: { __typename?: 'SummitTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SummitTypeEdge', node: { __typename?: 'SummitType', id: string, name: string, startDate: string, endDate: string, imageUrl?: string | null, introVideoUrl?: string | null, description: string, matchAlgorithm: MatchAlgorithmType, skillModules: Array<{ __typename?: 'SkillModuleType', id: string }>, cohorts: Array<{ __typename?: 'CohortType', id: string, name: string, cohortType?: string | null, userCount: number, userproxyCount: number }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetStaffCohortsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetStaffCohortsQuery = { __typename?: 'Query', staffCohorts: { __typename?: 'CohortTypeConnection', edges: Array<{ __typename?: 'CohortTypeEdge', node: { __typename?: 'CohortType', id: string, name: string, cohortType?: string | null, userCount: number, userproxyCount: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetQuotaReportQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['GlobalID']>;
}>;


export type GetQuotaReportQuery = { __typename?: 'Query', quotaReport: { __typename?: 'QuotaReportType', quotaCompletedSessions?: number | null, monthlyCompletedSessions: number, activeSummitCompletion?: { __typename?: 'SummitCompletionReportType', totalActiveSkills: number, completedSkills: number, summit: { __typename?: 'SummitType', id: string, name: string } } | null, pastSummitCompletion: Array<{ __typename?: 'SummitCompletionReportType', totalActiveSkills: number, completedSkills: number, summit: { __typename?: 'SummitType', id: string, name: string } }> } };

export type GetStoreUsersParticipationQueryVariables = Exact<{
  getUserStoreRequest: GetUserStoreRequest;
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetStoreUsersParticipationQuery = { __typename?: 'Query', store?: { __typename?: 'StoreType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, childrenCompletedQuota?: number | null, userCount: number, users: { __typename?: 'UserTypeConnection', edges: Array<{ __typename?: 'UserTypeEdge', node: { __typename?: 'UserType', id: string, firstName: string, lastName: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, leader?: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, profileImgLgUrl: string, title?: string | null, hireDate?: string | null } | null, district?: { __typename?: 'DistrictType', id: string, name: string } | null, region?: { __typename?: 'RegionType', id: string, name: string } | null, organization: { __typename?: 'OrganizationType', id: string, name: string } } | null };

export type GetDistrictStoresParticipationQueryVariables = Exact<{
  getUserDistrictRequest: GetUserDistrictRequest;
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDistrictStoresParticipationQuery = { __typename?: 'Query', district?: { __typename?: 'DistrictType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, childrenCompletedQuota?: number | null, storeCount: number, stores: { __typename?: 'StoreTypeConnection', edges: Array<{ __typename?: 'StoreTypeEdge', node: { __typename?: 'StoreType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, participatingUsers?: number | null, userCount: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, leader?: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, profileImgLgUrl: string, title?: string | null, hireDate?: string | null } | null, region: { __typename?: 'RegionType', id: string, name: string }, organization: { __typename?: 'OrganizationType', id: string, name: string } } | null };

export type GetRegionDistrictsParticipationQueryVariables = Exact<{
  getUserRegionRequest: GetUserRegionRequest;
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRegionDistrictsParticipationQuery = { __typename?: 'Query', region?: { __typename?: 'RegionType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, childrenCompletedQuota?: number | null, districtCount: number, districts: { __typename?: 'DistrictTypeConnection', edges: Array<{ __typename?: 'DistrictTypeEdge', node: { __typename?: 'DistrictType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, participatingUsers?: number | null, userCount: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, leader?: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, profileImgLgUrl: string, title?: string | null, hireDate?: string | null } | null, organization: { __typename?: 'OrganizationType', id: string, name: string } } | null };

export type GetOrgRegionsParticipationQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
  isOnTrack?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrgRegionsParticipationQuery = { __typename?: 'Query', user: { __typename?: 'UserType', organization?: { __typename?: 'OrganizationType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, childrenCompletedQuota?: number | null, regionCount: number, regions: { __typename?: 'RegionTypeConnection', edges: Array<{ __typename?: 'RegionTypeEdge', node: { __typename?: 'RegionType', id: string, name: string, quotaProgress?: number | null, quotaTarget?: number | null, isOnTrack?: boolean | null, participatingUsers?: number | null, userCount: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null } };

export type GetOrgQuotaCompletionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgQuotaCompletionQuery = { __typename?: 'Query', user: { __typename?: 'UserType', organization?: { __typename?: 'OrganizationType', quotaProgress?: number | null, quotaTarget?: number | null } | null } };

export type GetUserParticipationQueryVariables = Exact<{
  userId: Scalars['GlobalID'];
}>;


export type GetUserParticipationQuery = { __typename?: 'Query', user: { __typename?: 'UserType', id: string, name: string, firstName: string, lastName: string, quotaTarget?: number | null, quotaProgress?: number | null, isOnTrack?: boolean | null, organization?: { __typename?: 'OrganizationType', id: string, name: string } | null, district?: { __typename?: 'DistrictType', id: string, name: string } | null, region?: { __typename?: 'RegionType', id: string, name: string } | null, store?: { __typename?: 'StoreType', id: string, name: string, leader?: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string, profileImgLgUrl: string, title?: string | null, hireDate?: string | null } | null } | null } };

export type GetKudosQueryVariables = Exact<{
  getKudosRequest: GetKudosRequest2;
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetKudosQuery = { __typename?: 'Query', kudos2: { __typename?: 'KudosTypeConnection', edges: Array<{ __typename?: 'KudosTypeEdge', node: { __typename?: 'KudosType', id: string, categoryHelpfulTips: boolean, categoryKnowledgeable: boolean, categoryGoodConversation: boolean, categoryFriendly: boolean, message: string, created: string, approved?: boolean | null, sender: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string }, recipient: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImgSmUrl: string }, session?: { __typename?: 'SkaleSessionType', id: string, thumbnailUrl: string, duration: number, archiveUrl: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };


export const CreateCsvSendEmailDocument = gql`
    mutation CreateCsvSendEmail($createCsvSendEmailRequest: CreateCsvSendEmailRequest!) {
  createCsvSendEmail(createCsvSendEmailRequest: $createCsvSendEmailRequest) {
    ok
    recipient
    reason
  }
}
    `;
export type CreateCsvSendEmailMutationFn = Apollo.MutationFunction<CreateCsvSendEmailMutation, CreateCsvSendEmailMutationVariables>;

/**
 * __useCreateCsvSendEmailMutation__
 *
 * To run a mutation, you first call `useCreateCsvSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCsvSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCsvSendEmailMutation, { data, loading, error }] = useCreateCsvSendEmailMutation({
 *   variables: {
 *      createCsvSendEmailRequest: // value for 'createCsvSendEmailRequest'
 *   },
 * });
 */
export function useCreateCsvSendEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCsvSendEmailMutation, CreateCsvSendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCsvSendEmailMutation, CreateCsvSendEmailMutationVariables>(CreateCsvSendEmailDocument, options);
      }
export type CreateCsvSendEmailMutationHookResult = ReturnType<typeof useCreateCsvSendEmailMutation>;
export type CreateCsvSendEmailMutationResult = Apollo.MutationResult<CreateCsvSendEmailMutation>;
export type CreateCsvSendEmailMutationOptions = Apollo.BaseMutationOptions<CreateCsvSendEmailMutation, CreateCsvSendEmailMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser {
  deactivateUser {
    ok
  }
}
    `;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const DeactivateUserFromOrgDocument = gql`
    mutation DeactivateUserFromOrg($deactivateUserFromOrgRequest: DeactivateUserFromOrgRequest!) {
  deactivateUserFromOrg(
    deactivateUserFromOrgRequest: $deactivateUserFromOrgRequest
  ) {
    ok
  }
}
    `;
export type DeactivateUserFromOrgMutationFn = Apollo.MutationFunction<DeactivateUserFromOrgMutation, DeactivateUserFromOrgMutationVariables>;

/**
 * __useDeactivateUserFromOrgMutation__
 *
 * To run a mutation, you first call `useDeactivateUserFromOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserFromOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserFromOrgMutation, { data, loading, error }] = useDeactivateUserFromOrgMutation({
 *   variables: {
 *      deactivateUserFromOrgRequest: // value for 'deactivateUserFromOrgRequest'
 *   },
 * });
 */
export function useDeactivateUserFromOrgMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateUserFromOrgMutation, DeactivateUserFromOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateUserFromOrgMutation, DeactivateUserFromOrgMutationVariables>(DeactivateUserFromOrgDocument, options);
      }
export type DeactivateUserFromOrgMutationHookResult = ReturnType<typeof useDeactivateUserFromOrgMutation>;
export type DeactivateUserFromOrgMutationResult = Apollo.MutationResult<DeactivateUserFromOrgMutation>;
export type DeactivateUserFromOrgMutationOptions = Apollo.BaseMutationOptions<DeactivateUserFromOrgMutation, DeactivateUserFromOrgMutationVariables>;
export const DeclareMatchReadyDocument = gql`
    mutation DeclareMatchReady($declareMatchReadyRequest: DeclareMatchReadyRequest!) {
  declareMatchReady(declareMatchReadyRequest: $declareMatchReadyRequest) {
    ok
  }
}
    `;
export type DeclareMatchReadyMutationFn = Apollo.MutationFunction<DeclareMatchReadyMutation, DeclareMatchReadyMutationVariables>;

/**
 * __useDeclareMatchReadyMutation__
 *
 * To run a mutation, you first call `useDeclareMatchReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclareMatchReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declareMatchReadyMutation, { data, loading, error }] = useDeclareMatchReadyMutation({
 *   variables: {
 *      declareMatchReadyRequest: // value for 'declareMatchReadyRequest'
 *   },
 * });
 */
export function useDeclareMatchReadyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclareMatchReadyMutation, DeclareMatchReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclareMatchReadyMutation, DeclareMatchReadyMutationVariables>(DeclareMatchReadyDocument, options);
      }
export type DeclareMatchReadyMutationHookResult = ReturnType<typeof useDeclareMatchReadyMutation>;
export type DeclareMatchReadyMutationResult = Apollo.MutationResult<DeclareMatchReadyMutation>;
export type DeclareMatchReadyMutationOptions = Apollo.BaseMutationOptions<DeclareMatchReadyMutation, DeclareMatchReadyMutationVariables>;
export const DeclareMatchStepReadyDocument = gql`
    mutation DeclareMatchStepReady($declareMatchStepReadyRequest: DeclareMatchStepReadyRequest!) {
  declareMatchStepReady(
    declareMatchStepReadyRequest: $declareMatchStepReadyRequest
  ) {
    ok
  }
}
    `;
export type DeclareMatchStepReadyMutationFn = Apollo.MutationFunction<DeclareMatchStepReadyMutation, DeclareMatchStepReadyMutationVariables>;

/**
 * __useDeclareMatchStepReadyMutation__
 *
 * To run a mutation, you first call `useDeclareMatchStepReadyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclareMatchStepReadyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declareMatchStepReadyMutation, { data, loading, error }] = useDeclareMatchStepReadyMutation({
 *   variables: {
 *      declareMatchStepReadyRequest: // value for 'declareMatchStepReadyRequest'
 *   },
 * });
 */
export function useDeclareMatchStepReadyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclareMatchStepReadyMutation, DeclareMatchStepReadyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclareMatchStepReadyMutation, DeclareMatchStepReadyMutationVariables>(DeclareMatchStepReadyDocument, options);
      }
export type DeclareMatchStepReadyMutationHookResult = ReturnType<typeof useDeclareMatchStepReadyMutation>;
export type DeclareMatchStepReadyMutationResult = Apollo.MutationResult<DeclareMatchStepReadyMutation>;
export type DeclareMatchStepReadyMutationOptions = Apollo.BaseMutationOptions<DeclareMatchStepReadyMutation, DeclareMatchStepReadyMutationVariables>;
export const DeclareMatchCancelDocument = gql`
    mutation DeclareMatchCancel($declareMatchCancelRequest: DeclareMatchCancelRequest!) {
  declareMatchCancel(declareMatchCancelRequest: $declareMatchCancelRequest) {
    ok
  }
}
    `;
export type DeclareMatchCancelMutationFn = Apollo.MutationFunction<DeclareMatchCancelMutation, DeclareMatchCancelMutationVariables>;

/**
 * __useDeclareMatchCancelMutation__
 *
 * To run a mutation, you first call `useDeclareMatchCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclareMatchCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declareMatchCancelMutation, { data, loading, error }] = useDeclareMatchCancelMutation({
 *   variables: {
 *      declareMatchCancelRequest: // value for 'declareMatchCancelRequest'
 *   },
 * });
 */
export function useDeclareMatchCancelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclareMatchCancelMutation, DeclareMatchCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclareMatchCancelMutation, DeclareMatchCancelMutationVariables>(DeclareMatchCancelDocument, options);
      }
export type DeclareMatchCancelMutationHookResult = ReturnType<typeof useDeclareMatchCancelMutation>;
export type DeclareMatchCancelMutationResult = Apollo.MutationResult<DeclareMatchCancelMutation>;
export type DeclareMatchCancelMutationOptions = Apollo.BaseMutationOptions<DeclareMatchCancelMutation, DeclareMatchCancelMutationVariables>;
export const DeclareMatchEndDocument = gql`
    mutation DeclareMatchEnd($declareMatchEndRequest: DeclareMatchEndRequest!) {
  declareMatchEnd(declareMatchEndRequest: $declareMatchEndRequest) {
    ok
    reason
    isCancelled
  }
}
    `;
export type DeclareMatchEndMutationFn = Apollo.MutationFunction<DeclareMatchEndMutation, DeclareMatchEndMutationVariables>;

/**
 * __useDeclareMatchEndMutation__
 *
 * To run a mutation, you first call `useDeclareMatchEndMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclareMatchEndMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declareMatchEndMutation, { data, loading, error }] = useDeclareMatchEndMutation({
 *   variables: {
 *      declareMatchEndRequest: // value for 'declareMatchEndRequest'
 *   },
 * });
 */
export function useDeclareMatchEndMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclareMatchEndMutation, DeclareMatchEndMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclareMatchEndMutation, DeclareMatchEndMutationVariables>(DeclareMatchEndDocument, options);
      }
export type DeclareMatchEndMutationHookResult = ReturnType<typeof useDeclareMatchEndMutation>;
export type DeclareMatchEndMutationResult = Apollo.MutationResult<DeclareMatchEndMutation>;
export type DeclareMatchEndMutationOptions = Apollo.BaseMutationOptions<DeclareMatchEndMutation, DeclareMatchEndMutationVariables>;
export const SubmitFeedbackDocument = gql`
    mutation SubmitFeedback($submitFeedbackRequest: SubmitFeedbackRequest!) {
  submitFeedback(submitFeedbackRequest: $submitFeedbackRequest) {
    ok
    reason
  }
}
    `;
export type SubmitFeedbackMutationFn = Apollo.MutationFunction<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;

/**
 * __useSubmitFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutation, { data, loading, error }] = useSubmitFeedbackMutation({
 *   variables: {
 *      submitFeedbackRequest: // value for 'submitFeedbackRequest'
 *   },
 * });
 */
export function useSubmitFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>(SubmitFeedbackDocument, options);
      }
export type SubmitFeedbackMutationHookResult = ReturnType<typeof useSubmitFeedbackMutation>;
export type SubmitFeedbackMutationResult = Apollo.MutationResult<SubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;
export const SubmitAnswersDocument = gql`
    mutation SubmitAnswers($submitAnswersRequest: SubmitAnswersRequest!) {
  submitAnswers(submitAnswersRequest: $submitAnswersRequest) {
    ok
    reason
  }
}
    `;
export type SubmitAnswersMutationFn = Apollo.MutationFunction<SubmitAnswersMutation, SubmitAnswersMutationVariables>;

/**
 * __useSubmitAnswersMutation__
 *
 * To run a mutation, you first call `useSubmitAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAnswersMutation, { data, loading, error }] = useSubmitAnswersMutation({
 *   variables: {
 *      submitAnswersRequest: // value for 'submitAnswersRequest'
 *   },
 * });
 */
export function useSubmitAnswersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitAnswersMutation, SubmitAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitAnswersMutation, SubmitAnswersMutationVariables>(SubmitAnswersDocument, options);
      }
export type SubmitAnswersMutationHookResult = ReturnType<typeof useSubmitAnswersMutation>;
export type SubmitAnswersMutationResult = Apollo.MutationResult<SubmitAnswersMutation>;
export type SubmitAnswersMutationOptions = Apollo.BaseMutationOptions<SubmitAnswersMutation, SubmitAnswersMutationVariables>;
export const ReportIssueDocument = gql`
    mutation ReportIssue($reportIssueRequest: ReportIssueRequest!) {
  reportIssue(reportIssueRequest: $reportIssueRequest) {
    ok
    reason
  }
}
    `;
export type ReportIssueMutationFn = Apollo.MutationFunction<ReportIssueMutation, ReportIssueMutationVariables>;

/**
 * __useReportIssueMutation__
 *
 * To run a mutation, you first call `useReportIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportIssueMutation, { data, loading, error }] = useReportIssueMutation({
 *   variables: {
 *      reportIssueRequest: // value for 'reportIssueRequest'
 *   },
 * });
 */
export function useReportIssueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReportIssueMutation, ReportIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReportIssueMutation, ReportIssueMutationVariables>(ReportIssueDocument, options);
      }
export type ReportIssueMutationHookResult = ReturnType<typeof useReportIssueMutation>;
export type ReportIssueMutationResult = Apollo.MutationResult<ReportIssueMutation>;
export type ReportIssueMutationOptions = Apollo.BaseMutationOptions<ReportIssueMutation, ReportIssueMutationVariables>;
export const ReportSessionProblemDocument = gql`
    mutation reportSessionProblem($reportSessionProblemRequest: ReportSessionProblemRequest!) {
  reportSessionProblem(reportSessionProblemRequest: $reportSessionProblemRequest) {
    ok
    reason
  }
}
    `;
export type ReportSessionProblemMutationFn = Apollo.MutationFunction<ReportSessionProblemMutation, ReportSessionProblemMutationVariables>;

/**
 * __useReportSessionProblemMutation__
 *
 * To run a mutation, you first call `useReportSessionProblemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSessionProblemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSessionProblemMutation, { data, loading, error }] = useReportSessionProblemMutation({
 *   variables: {
 *      reportSessionProblemRequest: // value for 'reportSessionProblemRequest'
 *   },
 * });
 */
export function useReportSessionProblemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReportSessionProblemMutation, ReportSessionProblemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReportSessionProblemMutation, ReportSessionProblemMutationVariables>(ReportSessionProblemDocument, options);
      }
export type ReportSessionProblemMutationHookResult = ReturnType<typeof useReportSessionProblemMutation>;
export type ReportSessionProblemMutationResult = Apollo.MutationResult<ReportSessionProblemMutation>;
export type ReportSessionProblemMutationOptions = Apollo.BaseMutationOptions<ReportSessionProblemMutation, ReportSessionProblemMutationVariables>;
export const EditSummitDocument = gql`
    mutation EditSummit($editSummitMutationRequest: EditSummitMutationRequest!) {
  editSummit(editSummitMutationRequest: $editSummitMutationRequest) {
    ok
    reason
  }
}
    `;
export type EditSummitMutationFn = Apollo.MutationFunction<EditSummitMutation, EditSummitMutationVariables>;

/**
 * __useEditSummitMutation__
 *
 * To run a mutation, you first call `useEditSummitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSummitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSummitMutation, { data, loading, error }] = useEditSummitMutation({
 *   variables: {
 *      editSummitMutationRequest: // value for 'editSummitMutationRequest'
 *   },
 * });
 */
export function useEditSummitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditSummitMutation, EditSummitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditSummitMutation, EditSummitMutationVariables>(EditSummitDocument, options);
      }
export type EditSummitMutationHookResult = ReturnType<typeof useEditSummitMutation>;
export type EditSummitMutationResult = Apollo.MutationResult<EditSummitMutation>;
export type EditSummitMutationOptions = Apollo.BaseMutationOptions<EditSummitMutation, EditSummitMutationVariables>;
export const CreateSummitDocument = gql`
    mutation CreateSummit($createSummitMutationRequest: CreateSummitMutationRequest!) {
  createSummit(createSummitMutationRequest: $createSummitMutationRequest) {
    ok
    reason
    summitId
  }
}
    `;
export type CreateSummitMutationFn = Apollo.MutationFunction<CreateSummitMutation, CreateSummitMutationVariables>;

/**
 * __useCreateSummitMutation__
 *
 * To run a mutation, you first call `useCreateSummitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSummitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSummitMutation, { data, loading, error }] = useCreateSummitMutation({
 *   variables: {
 *      createSummitMutationRequest: // value for 'createSummitMutationRequest'
 *   },
 * });
 */
export function useCreateSummitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSummitMutation, CreateSummitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSummitMutation, CreateSummitMutationVariables>(CreateSummitDocument, options);
      }
export type CreateSummitMutationHookResult = ReturnType<typeof useCreateSummitMutation>;
export type CreateSummitMutationResult = Apollo.MutationResult<CreateSummitMutation>;
export type CreateSummitMutationOptions = Apollo.BaseMutationOptions<CreateSummitMutation, CreateSummitMutationVariables>;
export const CreateOrGetSummitShareLinkDocument = gql`
    mutation CreateOrGetSummitShareLink($createOrGetSummitShareLinkMutationRequest: CreateOrGetSummitShareLinkMutationRequest!) {
  createOrGetSummitShareLink(
    createOrGetSummitShareLinkMutationRequest: $createOrGetSummitShareLinkMutationRequest
  ) {
    ok
    reason
    inviteUuid
  }
}
    `;
export type CreateOrGetSummitShareLinkMutationFn = Apollo.MutationFunction<CreateOrGetSummitShareLinkMutation, CreateOrGetSummitShareLinkMutationVariables>;

/**
 * __useCreateOrGetSummitShareLinkMutation__
 *
 * To run a mutation, you first call `useCreateOrGetSummitShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrGetSummitShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrGetSummitShareLinkMutation, { data, loading, error }] = useCreateOrGetSummitShareLinkMutation({
 *   variables: {
 *      createOrGetSummitShareLinkMutationRequest: // value for 'createOrGetSummitShareLinkMutationRequest'
 *   },
 * });
 */
export function useCreateOrGetSummitShareLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrGetSummitShareLinkMutation, CreateOrGetSummitShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrGetSummitShareLinkMutation, CreateOrGetSummitShareLinkMutationVariables>(CreateOrGetSummitShareLinkDocument, options);
      }
export type CreateOrGetSummitShareLinkMutationHookResult = ReturnType<typeof useCreateOrGetSummitShareLinkMutation>;
export type CreateOrGetSummitShareLinkMutationResult = Apollo.MutationResult<CreateOrGetSummitShareLinkMutation>;
export type CreateOrGetSummitShareLinkMutationOptions = Apollo.BaseMutationOptions<CreateOrGetSummitShareLinkMutation, CreateOrGetSummitShareLinkMutationVariables>;
export const EditSkalesessionDocument = gql`
    mutation EditSkalesession($editSkalesessionMutationRequest: EditSkalesessionMutationRequest!) {
  editSkalesession(
    editSkalesessionMutationRequest: $editSkalesessionMutationRequest
  ) {
    ok
    reason
    isCancelled
    allowSharing
    masteryEdited
  }
}
    `;
export type EditSkalesessionMutationFn = Apollo.MutationFunction<EditSkalesessionMutation, EditSkalesessionMutationVariables>;

/**
 * __useEditSkalesessionMutation__
 *
 * To run a mutation, you first call `useEditSkalesessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkalesessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkalesessionMutation, { data, loading, error }] = useEditSkalesessionMutation({
 *   variables: {
 *      editSkalesessionMutationRequest: // value for 'editSkalesessionMutationRequest'
 *   },
 * });
 */
export function useEditSkalesessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditSkalesessionMutation, EditSkalesessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditSkalesessionMutation, EditSkalesessionMutationVariables>(EditSkalesessionDocument, options);
      }
export type EditSkalesessionMutationHookResult = ReturnType<typeof useEditSkalesessionMutation>;
export type EditSkalesessionMutationResult = Apollo.MutationResult<EditSkalesessionMutation>;
export type EditSkalesessionMutationOptions = Apollo.BaseMutationOptions<EditSkalesessionMutation, EditSkalesessionMutationVariables>;
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($createAnnouncementMutationRequest: CreateAnnouncementMutationRequest!) {
  createAnnouncement(
    createAnnouncementMutationRequest: $createAnnouncementMutationRequest
  ) {
    ok
    reason
  }
}
    `;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      createAnnouncementMutationRequest: // value for 'createAnnouncementMutationRequest'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const EditAnnouncementDocument = gql`
    mutation EditAnnouncement($editAnnouncementMutationRequest: EditAnnouncementMutationRequest!) {
  editAnnouncement(
    editAnnouncementMutationRequest: $editAnnouncementMutationRequest
  ) {
    ok
    reason
  }
}
    `;
export type EditAnnouncementMutationFn = Apollo.MutationFunction<EditAnnouncementMutation, EditAnnouncementMutationVariables>;

/**
 * __useEditAnnouncementMutation__
 *
 * To run a mutation, you first call `useEditAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAnnouncementMutation, { data, loading, error }] = useEditAnnouncementMutation({
 *   variables: {
 *      editAnnouncementMutationRequest: // value for 'editAnnouncementMutationRequest'
 *   },
 * });
 */
export function useEditAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditAnnouncementMutation, EditAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditAnnouncementMutation, EditAnnouncementMutationVariables>(EditAnnouncementDocument, options);
      }
export type EditAnnouncementMutationHookResult = ReturnType<typeof useEditAnnouncementMutation>;
export type EditAnnouncementMutationResult = Apollo.MutationResult<EditAnnouncementMutation>;
export type EditAnnouncementMutationOptions = Apollo.BaseMutationOptions<EditAnnouncementMutation, EditAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = gql`
    mutation DeleteAnnouncement($deleteAnnouncementMutationRequest: DeleteAnnouncementMutationRequest!) {
  deleteAnnouncement(
    deleteAnnouncementMutationRequest: $deleteAnnouncementMutationRequest
  ) {
    ok
    reason
  }
}
    `;
export type DeleteAnnouncementMutationFn = Apollo.MutationFunction<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      deleteAnnouncementMutationRequest: // value for 'deleteAnnouncementMutationRequest'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>(DeleteAnnouncementDocument, options);
      }
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationResult = Apollo.MutationResult<DeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationOptions = Apollo.BaseMutationOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const PrimaryJoinOrgDocument = gql`
    mutation PrimaryJoinOrg($primaryJoinOrgRequest: PrimaryJoinOrgRequest!) {
  primaryJoinOrg(primaryJoinOrgRequest: $primaryJoinOrgRequest) {
    ok
    id
    reason
  }
}
    `;
export type PrimaryJoinOrgMutationFn = Apollo.MutationFunction<PrimaryJoinOrgMutation, PrimaryJoinOrgMutationVariables>;

/**
 * __usePrimaryJoinOrgMutation__
 *
 * To run a mutation, you first call `usePrimaryJoinOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimaryJoinOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primaryJoinOrgMutation, { data, loading, error }] = usePrimaryJoinOrgMutation({
 *   variables: {
 *      primaryJoinOrgRequest: // value for 'primaryJoinOrgRequest'
 *   },
 * });
 */
export function usePrimaryJoinOrgMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrimaryJoinOrgMutation, PrimaryJoinOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrimaryJoinOrgMutation, PrimaryJoinOrgMutationVariables>(PrimaryJoinOrgDocument, options);
      }
export type PrimaryJoinOrgMutationHookResult = ReturnType<typeof usePrimaryJoinOrgMutation>;
export type PrimaryJoinOrgMutationResult = Apollo.MutationResult<PrimaryJoinOrgMutation>;
export type PrimaryJoinOrgMutationOptions = Apollo.BaseMutationOptions<PrimaryJoinOrgMutation, PrimaryJoinOrgMutationVariables>;
export const EditSkillModuleDocument = gql`
    mutation EditSkillModule($editSkillModuleRequest: EditSkillModuleRequest!) {
  editSkillModule(editSkillModuleRequest: $editSkillModuleRequest) {
    ok
    reason
    skillModule {
      id
      name
      order
      description
      isActive
      canBeReviewed
      activeSkillList {
        edges {
          node {
            id
            order
            name
            description
            isPublished
            isActive
            areRatingsEnabled
          }
        }
      }
    }
  }
}
    `;
export type EditSkillModuleMutationFn = Apollo.MutationFunction<EditSkillModuleMutation, EditSkillModuleMutationVariables>;

/**
 * __useEditSkillModuleMutation__
 *
 * To run a mutation, you first call `useEditSkillModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillModuleMutation, { data, loading, error }] = useEditSkillModuleMutation({
 *   variables: {
 *      editSkillModuleRequest: // value for 'editSkillModuleRequest'
 *   },
 * });
 */
export function useEditSkillModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditSkillModuleMutation, EditSkillModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditSkillModuleMutation, EditSkillModuleMutationVariables>(EditSkillModuleDocument, options);
      }
export type EditSkillModuleMutationHookResult = ReturnType<typeof useEditSkillModuleMutation>;
export type EditSkillModuleMutationResult = Apollo.MutationResult<EditSkillModuleMutation>;
export type EditSkillModuleMutationOptions = Apollo.BaseMutationOptions<EditSkillModuleMutation, EditSkillModuleMutationVariables>;
export const EditSkillDocument = gql`
    mutation EditSkill($editSkillRequest: EditSkillRequest!) {
  editSkill(editSkillRequest: $editSkillRequest) {
    ok
    reason
    skill {
      id
      name
      order
      description
      isActive
      isPublished
      areRatingsEnabled
    }
    message
  }
}
    `;
export type EditSkillMutationFn = Apollo.MutationFunction<EditSkillMutation, EditSkillMutationVariables>;

/**
 * __useEditSkillMutation__
 *
 * To run a mutation, you first call `useEditSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillMutation, { data, loading, error }] = useEditSkillMutation({
 *   variables: {
 *      editSkillRequest: // value for 'editSkillRequest'
 *   },
 * });
 */
export function useEditSkillMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditSkillMutation, EditSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditSkillMutation, EditSkillMutationVariables>(EditSkillDocument, options);
      }
export type EditSkillMutationHookResult = ReturnType<typeof useEditSkillMutation>;
export type EditSkillMutationResult = Apollo.MutationResult<EditSkillMutation>;
export type EditSkillMutationOptions = Apollo.BaseMutationOptions<EditSkillMutation, EditSkillMutationVariables>;
export const CreateSkillModuleDocument = gql`
    mutation CreateSkillModule($createSkillModuleRequest: CreateSkillModuleRequest!) {
  createSkillModule(createSkillModuleRequest: $createSkillModuleRequest) {
    ok
    reason
    skillModule {
      id
      name
      order
      description
      isActive
      canBeReviewed
    }
  }
}
    `;
export type CreateSkillModuleMutationFn = Apollo.MutationFunction<CreateSkillModuleMutation, CreateSkillModuleMutationVariables>;

/**
 * __useCreateSkillModuleMutation__
 *
 * To run a mutation, you first call `useCreateSkillModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillModuleMutation, { data, loading, error }] = useCreateSkillModuleMutation({
 *   variables: {
 *      createSkillModuleRequest: // value for 'createSkillModuleRequest'
 *   },
 * });
 */
export function useCreateSkillModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSkillModuleMutation, CreateSkillModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSkillModuleMutation, CreateSkillModuleMutationVariables>(CreateSkillModuleDocument, options);
      }
export type CreateSkillModuleMutationHookResult = ReturnType<typeof useCreateSkillModuleMutation>;
export type CreateSkillModuleMutationResult = Apollo.MutationResult<CreateSkillModuleMutation>;
export type CreateSkillModuleMutationOptions = Apollo.BaseMutationOptions<CreateSkillModuleMutation, CreateSkillModuleMutationVariables>;
export const CreateSkillDocument = gql`
    mutation CreateSkill($createSkillRequest: CreateSkillRequest!) {
  createSkill(createSkillRequest: $createSkillRequest) {
    ok
    reason
    skill {
      id
      name
      order
      description
      isActive
      isPublished
      areRatingsEnabled
    }
  }
}
    `;
export type CreateSkillMutationFn = Apollo.MutationFunction<CreateSkillMutation, CreateSkillMutationVariables>;

/**
 * __useCreateSkillMutation__
 *
 * To run a mutation, you first call `useCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillMutation, { data, loading, error }] = useCreateSkillMutation({
 *   variables: {
 *      createSkillRequest: // value for 'createSkillRequest'
 *   },
 * });
 */
export function useCreateSkillMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSkillMutation, CreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSkillMutation, CreateSkillMutationVariables>(CreateSkillDocument, options);
      }
export type CreateSkillMutationHookResult = ReturnType<typeof useCreateSkillMutation>;
export type CreateSkillMutationResult = Apollo.MutationResult<CreateSkillMutation>;
export type CreateSkillMutationOptions = Apollo.BaseMutationOptions<CreateSkillMutation, CreateSkillMutationVariables>;
export const EditUserDocument = gql`
    mutation EditUser($editUserRequest: EditUserRequest!) {
  editUser(editUserRequest: $editUserRequest) {
    ok
    reason
    isAdmin
    isStaff
    isManager
    isTrainer
    isCoach
  }
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      editUserRequest: // value for 'editUserRequest'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const UpdateTimeWindowDocument = gql`
    mutation UpdateTimeWindow($updateTimeWindowRequest: UpdateTimeWindowRequest!) {
  updateTimeWindow(updateTimeWindowRequest: $updateTimeWindowRequest) {
    ok
    reason
    timeWindowId
  }
}
    `;
export type UpdateTimeWindowMutationFn = Apollo.MutationFunction<UpdateTimeWindowMutation, UpdateTimeWindowMutationVariables>;

/**
 * __useUpdateTimeWindowMutation__
 *
 * To run a mutation, you first call `useUpdateTimeWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeWindowMutation, { data, loading, error }] = useUpdateTimeWindowMutation({
 *   variables: {
 *      updateTimeWindowRequest: // value for 'updateTimeWindowRequest'
 *   },
 * });
 */
export function useUpdateTimeWindowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTimeWindowMutation, UpdateTimeWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTimeWindowMutation, UpdateTimeWindowMutationVariables>(UpdateTimeWindowDocument, options);
      }
export type UpdateTimeWindowMutationHookResult = ReturnType<typeof useUpdateTimeWindowMutation>;
export type UpdateTimeWindowMutationResult = Apollo.MutationResult<UpdateTimeWindowMutation>;
export type UpdateTimeWindowMutationOptions = Apollo.BaseMutationOptions<UpdateTimeWindowMutation, UpdateTimeWindowMutationVariables>;
export const DeactivateTimeWindowDocument = gql`
    mutation DeactivateTimeWindow($deactivateTimeWindowRequest: DeactivateTimeWindowRequest!) {
  deactivateTimeWindow(deactivateTimeWindowRequest: $deactivateTimeWindowRequest) {
    ok
    reason
  }
}
    `;
export type DeactivateTimeWindowMutationFn = Apollo.MutationFunction<DeactivateTimeWindowMutation, DeactivateTimeWindowMutationVariables>;

/**
 * __useDeactivateTimeWindowMutation__
 *
 * To run a mutation, you first call `useDeactivateTimeWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTimeWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTimeWindowMutation, { data, loading, error }] = useDeactivateTimeWindowMutation({
 *   variables: {
 *      deactivateTimeWindowRequest: // value for 'deactivateTimeWindowRequest'
 *   },
 * });
 */
export function useDeactivateTimeWindowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateTimeWindowMutation, DeactivateTimeWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateTimeWindowMutation, DeactivateTimeWindowMutationVariables>(DeactivateTimeWindowDocument, options);
      }
export type DeactivateTimeWindowMutationHookResult = ReturnType<typeof useDeactivateTimeWindowMutation>;
export type DeactivateTimeWindowMutationResult = Apollo.MutationResult<DeactivateTimeWindowMutation>;
export type DeactivateTimeWindowMutationOptions = Apollo.BaseMutationOptions<DeactivateTimeWindowMutation, DeactivateTimeWindowMutationVariables>;
export const ApproveKudosDocument = gql`
    mutation ApproveKudos($approveKudosRequest: ApproveKudosRequest!) {
  approveKudos(approveKudosRequest: $approveKudosRequest) {
    ok
    reason
  }
}
    `;
export type ApproveKudosMutationFn = Apollo.MutationFunction<ApproveKudosMutation, ApproveKudosMutationVariables>;

/**
 * __useApproveKudosMutation__
 *
 * To run a mutation, you first call `useApproveKudosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveKudosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveKudosMutation, { data, loading, error }] = useApproveKudosMutation({
 *   variables: {
 *      approveKudosRequest: // value for 'approveKudosRequest'
 *   },
 * });
 */
export function useApproveKudosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveKudosMutation, ApproveKudosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveKudosMutation, ApproveKudosMutationVariables>(ApproveKudosDocument, options);
      }
export type ApproveKudosMutationHookResult = ReturnType<typeof useApproveKudosMutation>;
export type ApproveKudosMutationResult = Apollo.MutationResult<ApproveKudosMutation>;
export type ApproveKudosMutationOptions = Apollo.BaseMutationOptions<ApproveKudosMutation, ApproveKudosMutationVariables>;
export const LogSessionViewDocument = gql`
    mutation LogSessionView($logSessionViewRequest: LogSessionViewRequest!) {
  logSessionView(logSessionViewRequest: $logSessionViewRequest) {
    ok
    reason
  }
}
    `;
export type LogSessionViewMutationFn = Apollo.MutationFunction<LogSessionViewMutation, LogSessionViewMutationVariables>;

/**
 * __useLogSessionViewMutation__
 *
 * To run a mutation, you first call `useLogSessionViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogSessionViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logSessionViewMutation, { data, loading, error }] = useLogSessionViewMutation({
 *   variables: {
 *      logSessionViewRequest: // value for 'logSessionViewRequest'
 *   },
 * });
 */
export function useLogSessionViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogSessionViewMutation, LogSessionViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogSessionViewMutation, LogSessionViewMutationVariables>(LogSessionViewDocument, options);
      }
export type LogSessionViewMutationHookResult = ReturnType<typeof useLogSessionViewMutation>;
export type LogSessionViewMutationResult = Apollo.MutationResult<LogSessionViewMutation>;
export type LogSessionViewMutationOptions = Apollo.BaseMutationOptions<LogSessionViewMutation, LogSessionViewMutationVariables>;
export const SendKudosDocument = gql`
    mutation sendKudos($sendKudosRequest: SendKudosRequest!) {
  sendKudos(sendKudosRequest: $sendKudosRequest) {
    ok
    reason
  }
}
    `;
export type SendKudosMutationFn = Apollo.MutationFunction<SendKudosMutation, SendKudosMutationVariables>;

/**
 * __useSendKudosMutation__
 *
 * To run a mutation, you first call `useSendKudosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendKudosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendKudosMutation, { data, loading, error }] = useSendKudosMutation({
 *   variables: {
 *      sendKudosRequest: // value for 'sendKudosRequest'
 *   },
 * });
 */
export function useSendKudosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendKudosMutation, SendKudosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendKudosMutation, SendKudosMutationVariables>(SendKudosDocument, options);
      }
export type SendKudosMutationHookResult = ReturnType<typeof useSendKudosMutation>;
export type SendKudosMutationResult = Apollo.MutationResult<SendKudosMutation>;
export type SendKudosMutationOptions = Apollo.BaseMutationOptions<SendKudosMutation, SendKudosMutationVariables>;
export const GetDistrictLeaderboardDocument = gql`
    query GetDistrictLeaderboard($getUserDistrictRequest: GetUserDistrictRequest) {
  district(getUserDistrictRequest: $getUserDistrictRequest) {
    name
    isActive
    organization {
      name
    }
    storeCount
    userCount
    activeUserList {
      edges {
        node {
          id
          firstName
          lastName
          primaryEmail
          title
          profileImgLgUrl
          profileImgSmUrl
          currMonthSessionCount
          isActive
        }
      }
    }
  }
}
    `;

/**
 * __useGetDistrictLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetDistrictLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictLeaderboardQuery({
 *   variables: {
 *      getUserDistrictRequest: // value for 'getUserDistrictRequest'
 *   },
 * });
 */
export function useGetDistrictLeaderboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDistrictLeaderboardQuery, GetDistrictLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDistrictLeaderboardQuery, GetDistrictLeaderboardQueryVariables>(GetDistrictLeaderboardDocument, options);
      }
export function useGetDistrictLeaderboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDistrictLeaderboardQuery, GetDistrictLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDistrictLeaderboardQuery, GetDistrictLeaderboardQueryVariables>(GetDistrictLeaderboardDocument, options);
        }
export type GetDistrictLeaderboardQueryHookResult = ReturnType<typeof useGetDistrictLeaderboardQuery>;
export type GetDistrictLeaderboardLazyQueryHookResult = ReturnType<typeof useGetDistrictLeaderboardLazyQuery>;
export type GetDistrictLeaderboardQueryResult = Apollo.QueryResult<GetDistrictLeaderboardQuery, GetDistrictLeaderboardQueryVariables>;
export const GetUserRegionInfoDocument = gql`
    query GetUserRegionInfo($getUserRegionRequest: GetUserRegionRequest!) {
  region(getUserRegionRequest: $getUserRegionRequest) {
    id
    name
    districtCount
    storeCount
    userCount
  }
}
    `;

/**
 * __useGetUserRegionInfoQuery__
 *
 * To run a query within a React component, call `useGetUserRegionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRegionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRegionInfoQuery({
 *   variables: {
 *      getUserRegionRequest: // value for 'getUserRegionRequest'
 *   },
 * });
 */
export function useGetUserRegionInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserRegionInfoQuery, GetUserRegionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserRegionInfoQuery, GetUserRegionInfoQueryVariables>(GetUserRegionInfoDocument, options);
      }
export function useGetUserRegionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserRegionInfoQuery, GetUserRegionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserRegionInfoQuery, GetUserRegionInfoQueryVariables>(GetUserRegionInfoDocument, options);
        }
export type GetUserRegionInfoQueryHookResult = ReturnType<typeof useGetUserRegionInfoQuery>;
export type GetUserRegionInfoLazyQueryHookResult = ReturnType<typeof useGetUserRegionInfoLazyQuery>;
export type GetUserRegionInfoQueryResult = Apollo.QueryResult<GetUserRegionInfoQuery, GetUserRegionInfoQueryVariables>;
export const GetUserDistrictInfoDocument = gql`
    query GetUserDistrictInfo($getUserDistrictRequest: GetUserDistrictRequest!) {
  district(getUserDistrictRequest: $getUserDistrictRequest) {
    id
    name
    storeCount
    userCount
    region {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserDistrictInfoQuery__
 *
 * To run a query within a React component, call `useGetUserDistrictInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDistrictInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDistrictInfoQuery({
 *   variables: {
 *      getUserDistrictRequest: // value for 'getUserDistrictRequest'
 *   },
 * });
 */
export function useGetUserDistrictInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserDistrictInfoQuery, GetUserDistrictInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserDistrictInfoQuery, GetUserDistrictInfoQueryVariables>(GetUserDistrictInfoDocument, options);
      }
export function useGetUserDistrictInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserDistrictInfoQuery, GetUserDistrictInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserDistrictInfoQuery, GetUserDistrictInfoQueryVariables>(GetUserDistrictInfoDocument, options);
        }
export type GetUserDistrictInfoQueryHookResult = ReturnType<typeof useGetUserDistrictInfoQuery>;
export type GetUserDistrictInfoLazyQueryHookResult = ReturnType<typeof useGetUserDistrictInfoLazyQuery>;
export type GetUserDistrictInfoQueryResult = Apollo.QueryResult<GetUserDistrictInfoQuery, GetUserDistrictInfoQueryVariables>;
export const GetUserStoreInfoDocument = gql`
    query GetUserStoreInfo($getUserStoreRequest: GetUserStoreRequest!) {
  store(getUserStoreRequest: $getUserStoreRequest) {
    id
    name
    userCount
    region {
      id
      name
    }
    district {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserStoreInfoQuery__
 *
 * To run a query within a React component, call `useGetUserStoreInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStoreInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStoreInfoQuery({
 *   variables: {
 *      getUserStoreRequest: // value for 'getUserStoreRequest'
 *   },
 * });
 */
export function useGetUserStoreInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserStoreInfoQuery, GetUserStoreInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserStoreInfoQuery, GetUserStoreInfoQueryVariables>(GetUserStoreInfoDocument, options);
      }
export function useGetUserStoreInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserStoreInfoQuery, GetUserStoreInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserStoreInfoQuery, GetUserStoreInfoQueryVariables>(GetUserStoreInfoDocument, options);
        }
export type GetUserStoreInfoQueryHookResult = ReturnType<typeof useGetUserStoreInfoQuery>;
export type GetUserStoreInfoLazyQueryHookResult = ReturnType<typeof useGetUserStoreInfoLazyQuery>;
export type GetUserStoreInfoQueryResult = Apollo.QueryResult<GetUserStoreInfoQuery, GetUserStoreInfoQueryVariables>;
export const GetStoreListDocument = gql`
    query GetStoreList {
  stores {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStoreListQuery__
 *
 * To run a query within a React component, call `useGetStoreListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoreListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStoreListQuery, GetStoreListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStoreListQuery, GetStoreListQueryVariables>(GetStoreListDocument, options);
      }
export function useGetStoreListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStoreListQuery, GetStoreListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStoreListQuery, GetStoreListQueryVariables>(GetStoreListDocument, options);
        }
export type GetStoreListQueryHookResult = ReturnType<typeof useGetStoreListQuery>;
export type GetStoreListLazyQueryHookResult = ReturnType<typeof useGetStoreListLazyQuery>;
export type GetStoreListQueryResult = Apollo.QueryResult<GetStoreListQuery, GetStoreListQueryVariables>;
export const GetRegionListDocument = gql`
    query GetRegionList {
  regions {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRegionListQuery__
 *
 * To run a query within a React component, call `useGetRegionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRegionListQuery, GetRegionListQueryVariables>(GetRegionListDocument, options);
      }
export function useGetRegionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRegionListQuery, GetRegionListQueryVariables>(GetRegionListDocument, options);
        }
export type GetRegionListQueryHookResult = ReturnType<typeof useGetRegionListQuery>;
export type GetRegionListLazyQueryHookResult = ReturnType<typeof useGetRegionListLazyQuery>;
export type GetRegionListQueryResult = Apollo.QueryResult<GetRegionListQuery, GetRegionListQueryVariables>;
export const GetDistrictListDocument = gql`
    query GetDistrictList {
  districts {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDistrictListQuery__
 *
 * To run a query within a React component, call `useGetDistrictListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDistrictListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDistrictListQuery, GetDistrictListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDistrictListQuery, GetDistrictListQueryVariables>(GetDistrictListDocument, options);
      }
export function useGetDistrictListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDistrictListQuery, GetDistrictListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDistrictListQuery, GetDistrictListQueryVariables>(GetDistrictListDocument, options);
        }
export type GetDistrictListQueryHookResult = ReturnType<typeof useGetDistrictListQuery>;
export type GetDistrictListLazyQueryHookResult = ReturnType<typeof useGetDistrictListLazyQuery>;
export type GetDistrictListQueryResult = Apollo.QueryResult<GetDistrictListQuery, GetDistrictListQueryVariables>;
export const GetSkillListDocument = gql`
    query GetSkillList {
  skills {
    edges {
      node {
        id
        name
        isPublished
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetSkillListQuery__
 *
 * To run a query within a React component, call `useGetSkillListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSkillListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSkillListQuery, GetSkillListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSkillListQuery, GetSkillListQueryVariables>(GetSkillListDocument, options);
      }
export function useGetSkillListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSkillListQuery, GetSkillListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSkillListQuery, GetSkillListQueryVariables>(GetSkillListDocument, options);
        }
export type GetSkillListQueryHookResult = ReturnType<typeof useGetSkillListQuery>;
export type GetSkillListLazyQueryHookResult = ReturnType<typeof useGetSkillListLazyQuery>;
export type GetSkillListQueryResult = Apollo.QueryResult<GetSkillListQuery, GetSkillListQueryVariables>;
export const OrganizationDocument = gql`
    query organization($orgCode: String!) {
  organization(orgCode: $orgCode) {
    name
    orgCode
    orgJoinRule
    auth0ConnectionName
    isOpen
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const UserproxyDocument = gql`
    query userproxy($internalId: String!, $orgCode: String!) {
  userproxy(internalId: $internalId, orgCode: $orgCode) {
    internalId
    email
    title
    name
    firstName
    lastName
    userExists
  }
}
    `;

/**
 * __useUserproxyQuery__
 *
 * To run a query within a React component, call `useUserproxyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserproxyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserproxyQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useUserproxyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserproxyQuery, UserproxyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserproxyQuery, UserproxyQueryVariables>(UserproxyDocument, options);
      }
export function useUserproxyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserproxyQuery, UserproxyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserproxyQuery, UserproxyQueryVariables>(UserproxyDocument, options);
        }
export type UserproxyQueryHookResult = ReturnType<typeof useUserproxyQuery>;
export type UserproxyLazyQueryHookResult = ReturnType<typeof useUserproxyLazyQuery>;
export type UserproxyQueryResult = Apollo.QueryResult<UserproxyQuery, UserproxyQueryVariables>;
export const GetPrimaryMemberListDocument = gql`
    query GetPrimaryMemberList($primaryMemberUserList: Boolean!) {
  users(primaryMemberUserList: $primaryMemberUserList) {
    edges {
      node {
        id
        organization {
          id
          name
          orgCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetPrimaryMemberListQuery__
 *
 * To run a query within a React component, call `useGetPrimaryMemberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimaryMemberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimaryMemberListQuery({
 *   variables: {
 *      primaryMemberUserList: // value for 'primaryMemberUserList'
 *   },
 * });
 */
export function useGetPrimaryMemberListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPrimaryMemberListQuery, GetPrimaryMemberListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPrimaryMemberListQuery, GetPrimaryMemberListQueryVariables>(GetPrimaryMemberListDocument, options);
      }
export function useGetPrimaryMemberListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPrimaryMemberListQuery, GetPrimaryMemberListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPrimaryMemberListQuery, GetPrimaryMemberListQueryVariables>(GetPrimaryMemberListDocument, options);
        }
export type GetPrimaryMemberListQueryHookResult = ReturnType<typeof useGetPrimaryMemberListQuery>;
export type GetPrimaryMemberListLazyQueryHookResult = ReturnType<typeof useGetPrimaryMemberListLazyQuery>;
export type GetPrimaryMemberListQueryResult = Apollo.QueryResult<GetPrimaryMemberListQuery, GetPrimaryMemberListQueryVariables>;
export const GetMemberUserListDocument = gql`
    query GetMemberUserList($getStaffMemberUserListRequest: GetStaffMemberUserListRequest, $cursor: String) {
  staffUsers(
    first: 50
    getStaffMemberUserListRequest: $getStaffMemberUserListRequest
    after: $cursor
  ) {
    totalCount
    edges {
      node {
        id
        firstName
        lastName
        title
        internalId
        primaryEmail
        region {
          id
          name
        }
        district {
          id
          name
        }
        store {
          id
          name
        }
        hireDate
        created
        primaryLastLogin
        lastActive
        isAdmin
        isStaff
        isManager
        isTrainer
        isCoach
        profileImgSmUrl
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetMemberUserListQuery__
 *
 * To run a query within a React component, call `useGetMemberUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberUserListQuery({
 *   variables: {
 *      getStaffMemberUserListRequest: // value for 'getStaffMemberUserListRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMemberUserListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMemberUserListQuery, GetMemberUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMemberUserListQuery, GetMemberUserListQueryVariables>(GetMemberUserListDocument, options);
      }
export function useGetMemberUserListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMemberUserListQuery, GetMemberUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMemberUserListQuery, GetMemberUserListQueryVariables>(GetMemberUserListDocument, options);
        }
export type GetMemberUserListQueryHookResult = ReturnType<typeof useGetMemberUserListQuery>;
export type GetMemberUserListLazyQueryHookResult = ReturnType<typeof useGetMemberUserListLazyQuery>;
export type GetMemberUserListQueryResult = Apollo.QueryResult<GetMemberUserListQuery, GetMemberUserListQueryVariables>;
export const GetMemberUserSearchListDocument = gql`
    query GetMemberUserSearchList($getStaffMemberUserListRequest: GetStaffMemberUserListRequest, $cursor: String) {
  staffUsers(
    first: 50
    getStaffMemberUserListRequest: $getStaffMemberUserListRequest
    after: $cursor
  ) {
    totalCount
    edges {
      node {
        id
        firstName
        lastName
        primaryEmail
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetMemberUserSearchListQuery__
 *
 * To run a query within a React component, call `useGetMemberUserSearchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberUserSearchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberUserSearchListQuery({
 *   variables: {
 *      getStaffMemberUserListRequest: // value for 'getStaffMemberUserListRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMemberUserSearchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMemberUserSearchListQuery, GetMemberUserSearchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMemberUserSearchListQuery, GetMemberUserSearchListQueryVariables>(GetMemberUserSearchListDocument, options);
      }
export function useGetMemberUserSearchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMemberUserSearchListQuery, GetMemberUserSearchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMemberUserSearchListQuery, GetMemberUserSearchListQueryVariables>(GetMemberUserSearchListDocument, options);
        }
export type GetMemberUserSearchListQueryHookResult = ReturnType<typeof useGetMemberUserSearchListQuery>;
export type GetMemberUserSearchListLazyQueryHookResult = ReturnType<typeof useGetMemberUserSearchListLazyQuery>;
export type GetMemberUserSearchListQueryResult = Apollo.QueryResult<GetMemberUserSearchListQuery, GetMemberUserSearchListQueryVariables>;
export const GetUserproxiesListDocument = gql`
    query GetUserproxiesList($getStaffUserproxiesListRequest: GetStaffUserproxiesListRequest, $cursor: String) {
  staffUserproxies(
    first: 50
    getStaffUserproxiesListRequest: $getStaffUserproxiesListRequest
    after: $cursor
  ) {
    totalCount
    edges {
      node {
        email
        hireDate
        firstName
        lastName
        title
        internalId
        region {
          name
        }
        district {
          name
        }
        store {
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetUserproxiesListQuery__
 *
 * To run a query within a React component, call `useGetUserproxiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserproxiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserproxiesListQuery({
 *   variables: {
 *      getStaffUserproxiesListRequest: // value for 'getStaffUserproxiesListRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetUserproxiesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserproxiesListQuery, GetUserproxiesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserproxiesListQuery, GetUserproxiesListQueryVariables>(GetUserproxiesListDocument, options);
      }
export function useGetUserproxiesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserproxiesListQuery, GetUserproxiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserproxiesListQuery, GetUserproxiesListQueryVariables>(GetUserproxiesListDocument, options);
        }
export type GetUserproxiesListQueryHookResult = ReturnType<typeof useGetUserproxiesListQuery>;
export type GetUserproxiesListLazyQueryHookResult = ReturnType<typeof useGetUserproxiesListLazyQuery>;
export type GetUserproxiesListQueryResult = Apollo.QueryResult<GetUserproxiesListQuery, GetUserproxiesListQueryVariables>;
export const GetSessionListDocument = gql`
    query GetSessionList($getStaffSessionListRequest: GetStaffSessionListRequest!, $cursor: String) {
  staffSessions(
    first: 20
    getStaffSessionListRequest: $getStaffSessionListRequest
    after: $cursor
  ) {
    totalCount
    completedCount
    edges {
      node {
        id
        created
        duration
        archiveUrl
        isCancelled
        thumbnailUrl
        teacherRating
        teacherSelfRating
        learnerRating
        learnerSelfRating
        transcriptionUrl
        hasTranscript
        teacherSummit {
          name
        }
        learnerSummit {
          name
        }
        skill {
          id
          name
          titleTeacher
          titleLearner
        }
        learner {
          id
          firstName
          lastName
          profileImgSmUrl
          title
          store {
            name
          }
          cohort {
            name
          }
        }
        teacher {
          id
          firstName
          lastName
          profileImgSmUrl
          title
          store {
            name
          }
          cohort {
            name
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetSessionListQuery__
 *
 * To run a query within a React component, call `useGetSessionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionListQuery({
 *   variables: {
 *      getStaffSessionListRequest: // value for 'getStaffSessionListRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetSessionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionListQuery, GetSessionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionListQuery, GetSessionListQueryVariables>(GetSessionListDocument, options);
      }
export function useGetSessionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionListQuery, GetSessionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionListQuery, GetSessionListQueryVariables>(GetSessionListDocument, options);
        }
export type GetSessionListQueryHookResult = ReturnType<typeof useGetSessionListQuery>;
export type GetSessionListLazyQueryHookResult = ReturnType<typeof useGetSessionListLazyQuery>;
export type GetSessionListQueryResult = Apollo.QueryResult<GetSessionListQuery, GetSessionListQueryVariables>;
export const GetUserSessionListDocument = gql`
    query GetUserSessionList($first: Int!, $getUserSessionListRequest: GetUserSessionListRequest, $cursor: String) {
  userSessions(
    first: $first
    getUserSessionListRequest: $getUserSessionListRequest
    after: $cursor
  ) {
    completedCount
    edges {
      node {
        id
        created
        duration
        isCancelled
        cancelledReason
        thumbnailUrl
        skill {
          id
          name
        }
        learner {
          id
          firstName
          lastName
          title
          profileImgLgUrl
          profileImgSmUrl
        }
        teacher {
          id
          firstName
          lastName
          title
          profileImgLgUrl
          profileImgSmUrl
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetUserSessionListQuery__
 *
 * To run a query within a React component, call `useGetUserSessionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      getUserSessionListRequest: // value for 'getUserSessionListRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetUserSessionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserSessionListQuery, GetUserSessionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSessionListQuery, GetUserSessionListQueryVariables>(GetUserSessionListDocument, options);
      }
export function useGetUserSessionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSessionListQuery, GetUserSessionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSessionListQuery, GetUserSessionListQueryVariables>(GetUserSessionListDocument, options);
        }
export type GetUserSessionListQueryHookResult = ReturnType<typeof useGetUserSessionListQuery>;
export type GetUserSessionListLazyQueryHookResult = ReturnType<typeof useGetUserSessionListLazyQuery>;
export type GetUserSessionListQueryResult = Apollo.QueryResult<GetUserSessionListQuery, GetUserSessionListQueryVariables>;
export const GetStaffSessionSecretDocument = gql`
    query GetStaffSessionSecret($getStaffSessionSecretRequest: GetStaffSessionSecretRequest!) {
  staffSession(getStaffSessionSecretRequest: $getStaffSessionSecretRequest) {
    id
    created
    organization {
      id
      name
      showProprietaryPopup
    }
    teacher {
      id
      firstName
      lastName
      email
      profileImgSmUrl
      title
      store {
        name
      }
    }
    learner {
      id
      firstName
      lastName
      email
      profileImgSmUrl
      title
      store {
        name
      }
    }
    skill {
      name
      titleTeacher
      titleLearner
    }
    teacherRating
    teacherSelfRating
    learnerRating
    learnerSelfRating
    masteryLevel
    masteryEdited
    allowSharing
    sessionSteps
    stepsReadyTeacher
    stepsReadyLearner
    archiveUrl
    transcriptionUrl
    hasTranscript
    isCancelled
  }
}
    `;

/**
 * __useGetStaffSessionSecretQuery__
 *
 * To run a query within a React component, call `useGetStaffSessionSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffSessionSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffSessionSecretQuery({
 *   variables: {
 *      getStaffSessionSecretRequest: // value for 'getStaffSessionSecretRequest'
 *   },
 * });
 */
export function useGetStaffSessionSecretQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStaffSessionSecretQuery, GetStaffSessionSecretQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffSessionSecretQuery, GetStaffSessionSecretQueryVariables>(GetStaffSessionSecretDocument, options);
      }
export function useGetStaffSessionSecretLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffSessionSecretQuery, GetStaffSessionSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffSessionSecretQuery, GetStaffSessionSecretQueryVariables>(GetStaffSessionSecretDocument, options);
        }
export type GetStaffSessionSecretQueryHookResult = ReturnType<typeof useGetStaffSessionSecretQuery>;
export type GetStaffSessionSecretLazyQueryHookResult = ReturnType<typeof useGetStaffSessionSecretLazyQuery>;
export type GetStaffSessionSecretQueryResult = Apollo.QueryResult<GetStaffSessionSecretQuery, GetStaffSessionSecretQueryVariables>;
export const GetStaffUserInfoDocument = gql`
    query GetStaffUserInfo($getStaffUserInfoRequest: GetStaffUserInfoRequest!) {
  staffUser(getStaffUserInfoRequest: $getStaffUserInfoRequest) {
    id
    primaryEmail
    firstName
    lastName
    profileImgSmUrl
    profileImgLgUrl
    region {
      id
      name
    }
    district {
      id
      name
    }
    store {
      id
      name
      leader {
        firstName
        lastName
        profileImgSmUrl
      }
    }
    score
    sessionCount
    hasSeenTutorial
    title
  }
}
    `;

/**
 * __useGetStaffUserInfoQuery__
 *
 * To run a query within a React component, call `useGetStaffUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffUserInfoQuery({
 *   variables: {
 *      getStaffUserInfoRequest: // value for 'getStaffUserInfoRequest'
 *   },
 * });
 */
export function useGetStaffUserInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStaffUserInfoQuery, GetStaffUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffUserInfoQuery, GetStaffUserInfoQueryVariables>(GetStaffUserInfoDocument, options);
      }
export function useGetStaffUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffUserInfoQuery, GetStaffUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffUserInfoQuery, GetStaffUserInfoQueryVariables>(GetStaffUserInfoDocument, options);
        }
export type GetStaffUserInfoQueryHookResult = ReturnType<typeof useGetStaffUserInfoQuery>;
export type GetStaffUserInfoLazyQueryHookResult = ReturnType<typeof useGetStaffUserInfoLazyQuery>;
export type GetStaffUserInfoQueryResult = Apollo.QueryResult<GetStaffUserInfoQuery, GetStaffUserInfoQueryVariables>;
export const GetSkillDetailDocument = gql`
    query GetSkillDetail($getSkillDetailRequest: GetSkillDetailRequest!) {
  skill(getSkillDetailRequest: $getSkillDetailRequest) {
    id
    order
    name
    description
    titleTeacher
    titleLearner
    sessionSteps
    videoUrl
    isPublished
    isActive
    skillModule {
      id
      order
      name
    }
    suggestedTotalMinutes
    videoUrl
  }
}
    `;

/**
 * __useGetSkillDetailQuery__
 *
 * To run a query within a React component, call `useGetSkillDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillDetailQuery({
 *   variables: {
 *      getSkillDetailRequest: // value for 'getSkillDetailRequest'
 *   },
 * });
 */
export function useGetSkillDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSkillDetailQuery, GetSkillDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSkillDetailQuery, GetSkillDetailQueryVariables>(GetSkillDetailDocument, options);
      }
export function useGetSkillDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSkillDetailQuery, GetSkillDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSkillDetailQuery, GetSkillDetailQueryVariables>(GetSkillDetailDocument, options);
        }
export type GetSkillDetailQueryHookResult = ReturnType<typeof useGetSkillDetailQuery>;
export type GetSkillDetailLazyQueryHookResult = ReturnType<typeof useGetSkillDetailLazyQuery>;
export type GetSkillDetailQueryResult = Apollo.QueryResult<GetSkillDetailQuery, GetSkillDetailQueryVariables>;
export const GetMePrimaryDocument = gql`
    query GetMePrimary {
  user {
    id
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetMePrimaryQuery__
 *
 * To run a query within a React component, call `useGetMePrimaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMePrimaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMePrimaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMePrimaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMePrimaryQuery, GetMePrimaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMePrimaryQuery, GetMePrimaryQueryVariables>(GetMePrimaryDocument, options);
      }
export function useGetMePrimaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMePrimaryQuery, GetMePrimaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMePrimaryQuery, GetMePrimaryQueryVariables>(GetMePrimaryDocument, options);
        }
export type GetMePrimaryQueryHookResult = ReturnType<typeof useGetMePrimaryQuery>;
export type GetMePrimaryLazyQueryHookResult = ReturnType<typeof useGetMePrimaryLazyQuery>;
export type GetMePrimaryQueryResult = Apollo.QueryResult<GetMePrimaryQuery, GetMePrimaryQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  user {
    id
    primaryEmail
    firstName
    lastName
    channelName
    organization {
      id
      name
      domain
      orgCode
      isOpen
      isOpenStaff
      isOpenTrainer
      isOpenMaintenance
      hasTimeClockAlert
      logoUrl
      showDistrict
      showTranscription
      archiveRatio
      startButtonText
      launchDate
      allowTitleEdit
      orgType
      activeQuota {
        startDate
        endDate
        requiredSessionCount
      }
      auth0ConnectionName
      doAgoraForceTcp
      channelName
      managerDashboardEnabled
      cachedFieldsLastUpdated
      userCount
      userproxyCount
    }
    profileImgSmUrl
    profileImgLgUrl
    region {
      id
    }
    district {
      id
    }
    store {
      id
      name
    }
    score
    hasSeenTutorial
    isAdmin
    isManager
    isStaff
    isTrainer
    isCoach
    title
    isReceivingQueueUpdates
    leaderSummary {
      id
      isLeader
      type
    }
    type
    onesignalId
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetPrimaryMemberTokenDocument = gql`
    query GetPrimaryMemberToken($getPrimaryMemberTokenRequest: GetPrimaryMemberTokenRequest) {
  user(getPrimaryMemberTokenRequest: $getPrimaryMemberTokenRequest) {
    token
  }
}
    `;

/**
 * __useGetPrimaryMemberTokenQuery__
 *
 * To run a query within a React component, call `useGetPrimaryMemberTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimaryMemberTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimaryMemberTokenQuery({
 *   variables: {
 *      getPrimaryMemberTokenRequest: // value for 'getPrimaryMemberTokenRequest'
 *   },
 * });
 */
export function useGetPrimaryMemberTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPrimaryMemberTokenQuery, GetPrimaryMemberTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPrimaryMemberTokenQuery, GetPrimaryMemberTokenQueryVariables>(GetPrimaryMemberTokenDocument, options);
      }
export function useGetPrimaryMemberTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPrimaryMemberTokenQuery, GetPrimaryMemberTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPrimaryMemberTokenQuery, GetPrimaryMemberTokenQueryVariables>(GetPrimaryMemberTokenDocument, options);
        }
export type GetPrimaryMemberTokenQueryHookResult = ReturnType<typeof useGetPrimaryMemberTokenQuery>;
export type GetPrimaryMemberTokenLazyQueryHookResult = ReturnType<typeof useGetPrimaryMemberTokenLazyQuery>;
export type GetPrimaryMemberTokenQueryResult = Apollo.QueryResult<GetPrimaryMemberTokenQuery, GetPrimaryMemberTokenQueryVariables>;
export const GetSkaleSessionDocument = gql`
    query getSkaleSession($getSkaleSessionDetailRequest: GetSkaleSessionDetailRequest!) {
  skalesession(getSkaleSessionDetailRequest: $getSkaleSessionDetailRequest) {
    id
    summit {
      id
    }
    teacher {
      id
      firstName
      lastName
      title
      profileImgSmUrl
      profileImgLgUrl
      organization {
        name
      }
      district {
        name
      }
    }
    learner {
      id
      firstName
      lastName
      title
      profileImgSmUrl
      profileImgLgUrl
      organization {
        name
      }
      district {
        name
      }
    }
    skill {
      id
      name
      titleTeacher
      titleLearner
      description
      sessionSteps
      suggestedTotalMinutes
    }
    isTeacherReady
    isLearnerReady
    hasTeacherSeenContent
    hasLearnerSeenContent
    stepsReadyTeacher
    stepsReadyLearner
    isVendorMatch
    agoraChannel
  }
}
    `;

/**
 * __useGetSkaleSessionQuery__
 *
 * To run a query within a React component, call `useGetSkaleSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkaleSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkaleSessionQuery({
 *   variables: {
 *      getSkaleSessionDetailRequest: // value for 'getSkaleSessionDetailRequest'
 *   },
 * });
 */
export function useGetSkaleSessionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSkaleSessionQuery, GetSkaleSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSkaleSessionQuery, GetSkaleSessionQueryVariables>(GetSkaleSessionDocument, options);
      }
export function useGetSkaleSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSkaleSessionQuery, GetSkaleSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSkaleSessionQuery, GetSkaleSessionQueryVariables>(GetSkaleSessionDocument, options);
        }
export type GetSkaleSessionQueryHookResult = ReturnType<typeof useGetSkaleSessionQuery>;
export type GetSkaleSessionLazyQueryHookResult = ReturnType<typeof useGetSkaleSessionLazyQuery>;
export type GetSkaleSessionQueryResult = Apollo.QueryResult<GetSkaleSessionQuery, GetSkaleSessionQueryVariables>;
export const GetSummitDetailDocument = gql`
    query GetSummitDetail($getSummitRequest: GetSummitRequest!) {
  userSummit(getSummitRequest: $getSummitRequest) {
    id
    isPublished
    name
    inviteUuid
    description
    startDate
    endDate
    imageUrl
    introVideoUrl
    skillModules {
      id
      order
      name
      activeSkillList {
        edges {
          node {
            id
            order
            name
            description
            titleTeacher
            titleLearner
            sessionSteps
            videoUrl
            isPublished
            isActive
            skillModule {
              id
              order
              name
            }
            suggestedTotalMinutes
          }
        }
      }
      publishedSkillList {
        edges {
          node {
            id
            order
            name
            description
            titleTeacher
            titleLearner
            sessionSteps
            videoUrl
            isPublished
            isActive
            skillModule {
              id
              order
              name
            }
            suggestedTotalMinutes
          }
        }
      }
      isActive
    }
    cohorts {
      id
      name
      cohortType
    }
    matchAlgorithm
    organization {
      domain
      orgCode
      name
    }
    timeWindows {
      edges {
        node {
          id
          startTime
          endTime
          text
          order
        }
      }
    }
  }
}
    `;

/**
 * __useGetSummitDetailQuery__
 *
 * To run a query within a React component, call `useGetSummitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummitDetailQuery({
 *   variables: {
 *      getSummitRequest: // value for 'getSummitRequest'
 *   },
 * });
 */
export function useGetSummitDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSummitDetailQuery, GetSummitDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSummitDetailQuery, GetSummitDetailQueryVariables>(GetSummitDetailDocument, options);
      }
export function useGetSummitDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSummitDetailQuery, GetSummitDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSummitDetailQuery, GetSummitDetailQueryVariables>(GetSummitDetailDocument, options);
        }
export type GetSummitDetailQueryHookResult = ReturnType<typeof useGetSummitDetailQuery>;
export type GetSummitDetailLazyQueryHookResult = ReturnType<typeof useGetSummitDetailLazyQuery>;
export type GetSummitDetailQueryResult = Apollo.QueryResult<GetSummitDetailQuery, GetSummitDetailQueryVariables>;
export const GetUserSessionListQuotaCompletionDocument = gql`
    query GetUserSessionListQuotaCompletion($getUserSessionListRequest: GetUserSessionListRequest) {
  userSessions(first: 0, getUserSessionListRequest: $getUserSessionListRequest) {
    completedCount
  }
}
    `;

/**
 * __useGetUserSessionListQuotaCompletionQuery__
 *
 * To run a query within a React component, call `useGetUserSessionListQuotaCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionListQuotaCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionListQuotaCompletionQuery({
 *   variables: {
 *      getUserSessionListRequest: // value for 'getUserSessionListRequest'
 *   },
 * });
 */
export function useGetUserSessionListQuotaCompletionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserSessionListQuotaCompletionQuery, GetUserSessionListQuotaCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSessionListQuotaCompletionQuery, GetUserSessionListQuotaCompletionQueryVariables>(GetUserSessionListQuotaCompletionDocument, options);
      }
export function useGetUserSessionListQuotaCompletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSessionListQuotaCompletionQuery, GetUserSessionListQuotaCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSessionListQuotaCompletionQuery, GetUserSessionListQuotaCompletionQueryVariables>(GetUserSessionListQuotaCompletionDocument, options);
        }
export type GetUserSessionListQuotaCompletionQueryHookResult = ReturnType<typeof useGetUserSessionListQuotaCompletionQuery>;
export type GetUserSessionListQuotaCompletionLazyQueryHookResult = ReturnType<typeof useGetUserSessionListQuotaCompletionLazyQuery>;
export type GetUserSessionListQuotaCompletionQueryResult = Apollo.QueryResult<GetUserSessionListQuotaCompletionQuery, GetUserSessionListQuotaCompletionQueryVariables>;
export const GetStaffSummitListDocument = gql`
    query GetStaffSummitList {
  staffSummits {
    totalCount
    edges {
      node {
        id
        isPublished
        name
        inviteUuid
        description
        startDate
        endDate
        imageUrl
        introVideoUrl
        skillModules {
          id
          order
          name
          activeSkillList {
            edges {
              node {
                id
                order
                name
                description
                titleTeacher
                titleLearner
                sessionSteps
                videoUrl
                isPublished
                isActive
                skillModule {
                  id
                  order
                  name
                }
                suggestedTotalMinutes
              }
            }
          }
          publishedSkillList {
            edges {
              node {
                id
                order
                name
                description
                titleTeacher
                titleLearner
                sessionSteps
                videoUrl
                isPublished
                isActive
                skillModule {
                  id
                  order
                  name
                }
                suggestedTotalMinutes
              }
            }
          }
          isActive
        }
        matchAlgorithm
        organization {
          domain
          orgCode
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetStaffSummitListQuery__
 *
 * To run a query within a React component, call `useGetStaffSummitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffSummitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffSummitListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffSummitListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffSummitListQuery, GetStaffSummitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffSummitListQuery, GetStaffSummitListQueryVariables>(GetStaffSummitListDocument, options);
      }
export function useGetStaffSummitListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffSummitListQuery, GetStaffSummitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffSummitListQuery, GetStaffSummitListQueryVariables>(GetStaffSummitListDocument, options);
        }
export type GetStaffSummitListQueryHookResult = ReturnType<typeof useGetStaffSummitListQuery>;
export type GetStaffSummitListLazyQueryHookResult = ReturnType<typeof useGetStaffSummitListLazyQuery>;
export type GetStaffSummitListQueryResult = Apollo.QueryResult<GetStaffSummitListQuery, GetStaffSummitListQueryVariables>;
export const GetUserSummitSessionListDocument = gql`
    query GetUserSummitSessionList($getUserSummitSessionListRequest: GetUserSummitSessionListRequest) {
  skalesessions(getUserSummitSessionListRequest: $getUserSummitSessionListRequest) {
    edges {
      node {
        id
        learner {
          id
          firstName
          lastName
        }
        teacher {
          id
          firstName
          lastName
        }
        skill {
          id
          name
          suggestedTotalMinutes
          isPublished
        }
        created
        isCancelled
      }
    }
  }
}
    `;

/**
 * __useGetUserSummitSessionListQuery__
 *
 * To run a query within a React component, call `useGetUserSummitSessionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSummitSessionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSummitSessionListQuery({
 *   variables: {
 *      getUserSummitSessionListRequest: // value for 'getUserSummitSessionListRequest'
 *   },
 * });
 */
export function useGetUserSummitSessionListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserSummitSessionListQuery, GetUserSummitSessionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSummitSessionListQuery, GetUserSummitSessionListQueryVariables>(GetUserSummitSessionListDocument, options);
      }
export function useGetUserSummitSessionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSummitSessionListQuery, GetUserSummitSessionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSummitSessionListQuery, GetUserSummitSessionListQueryVariables>(GetUserSummitSessionListDocument, options);
        }
export type GetUserSummitSessionListQueryHookResult = ReturnType<typeof useGetUserSummitSessionListQuery>;
export type GetUserSummitSessionListLazyQueryHookResult = ReturnType<typeof useGetUserSummitSessionListLazyQuery>;
export type GetUserSummitSessionListQueryResult = Apollo.QueryResult<GetUserSummitSessionListQuery, GetUserSummitSessionListQueryVariables>;
export const SummitRouteGetSkillDetailDocument = gql`
    query SummitRouteGetSkillDetail($getSkillDetailRequest: GetSkillDetailRequest!) {
  skill(getSkillDetailRequest: $getSkillDetailRequest) {
    description
    isPublished
  }
}
    `;

/**
 * __useSummitRouteGetSkillDetailQuery__
 *
 * To run a query within a React component, call `useSummitRouteGetSkillDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummitRouteGetSkillDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummitRouteGetSkillDetailQuery({
 *   variables: {
 *      getSkillDetailRequest: // value for 'getSkillDetailRequest'
 *   },
 * });
 */
export function useSummitRouteGetSkillDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SummitRouteGetSkillDetailQuery, SummitRouteGetSkillDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SummitRouteGetSkillDetailQuery, SummitRouteGetSkillDetailQueryVariables>(SummitRouteGetSkillDetailDocument, options);
      }
export function useSummitRouteGetSkillDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SummitRouteGetSkillDetailQuery, SummitRouteGetSkillDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SummitRouteGetSkillDetailQuery, SummitRouteGetSkillDetailQueryVariables>(SummitRouteGetSkillDetailDocument, options);
        }
export type SummitRouteGetSkillDetailQueryHookResult = ReturnType<typeof useSummitRouteGetSkillDetailQuery>;
export type SummitRouteGetSkillDetailLazyQueryHookResult = ReturnType<typeof useSummitRouteGetSkillDetailLazyQuery>;
export type SummitRouteGetSkillDetailQueryResult = Apollo.QueryResult<SummitRouteGetSkillDetailQuery, SummitRouteGetSkillDetailQueryVariables>;
export const GetCurriculumDocument = gql`
    query GetCurriculum {
  staffSkillModules {
    edges {
      node {
        id
        order
        name
        description
        publishedSkillList {
          edges {
            node {
              id
              order
              name
              titleTeacher
            }
          }
        }
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetCurriculumQuery__
 *
 * To run a query within a React component, call `useGetCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurriculumQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurriculumQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurriculumQuery, GetCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurriculumQuery, GetCurriculumQueryVariables>(GetCurriculumDocument, options);
      }
export function useGetCurriculumLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurriculumQuery, GetCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurriculumQuery, GetCurriculumQueryVariables>(GetCurriculumDocument, options);
        }
export type GetCurriculumQueryHookResult = ReturnType<typeof useGetCurriculumQuery>;
export type GetCurriculumLazyQueryHookResult = ReturnType<typeof useGetCurriculumLazyQuery>;
export type GetCurriculumQueryResult = Apollo.QueryResult<GetCurriculumQuery, GetCurriculumQueryVariables>;
export const GetCohortsDocument = gql`
    query GetCohorts {
  staffCohorts {
    edges {
      node {
        id
        name
        cohortType
      }
    }
  }
}
    `;

/**
 * __useGetCohortsQuery__
 *
 * To run a query within a React component, call `useGetCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCohortsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCohortsQuery, GetCohortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCohortsQuery, GetCohortsQueryVariables>(GetCohortsDocument, options);
      }
export function useGetCohortsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCohortsQuery, GetCohortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCohortsQuery, GetCohortsQueryVariables>(GetCohortsDocument, options);
        }
export type GetCohortsQueryHookResult = ReturnType<typeof useGetCohortsQuery>;
export type GetCohortsLazyQueryHookResult = ReturnType<typeof useGetCohortsLazyQuery>;
export type GetCohortsQueryResult = Apollo.QueryResult<GetCohortsQuery, GetCohortsQueryVariables>;
export const GetSummitFeedbackListDocument = gql`
    query GetSummitFeedbackList($getSummitFeedbackRequest: GetSummitFeedbackRequest!, $cursor: String) {
  staffSummitFeedback(
    first: 15
    getSummitFeedbackRequest: $getSummitFeedbackRequest
    after: $cursor
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        created
        session {
          id
          thumbnailUrl
          archiveUrl
          duration
        }
        summit {
          id
          name
        }
        content
        user {
          id
          firstName
          lastName
          primaryEmail
        }
        role
      }
    }
  }
}
    `;

/**
 * __useGetSummitFeedbackListQuery__
 *
 * To run a query within a React component, call `useGetSummitFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummitFeedbackListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummitFeedbackListQuery({
 *   variables: {
 *      getSummitFeedbackRequest: // value for 'getSummitFeedbackRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetSummitFeedbackListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSummitFeedbackListQuery, GetSummitFeedbackListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSummitFeedbackListQuery, GetSummitFeedbackListQueryVariables>(GetSummitFeedbackListDocument, options);
      }
export function useGetSummitFeedbackListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSummitFeedbackListQuery, GetSummitFeedbackListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSummitFeedbackListQuery, GetSummitFeedbackListQueryVariables>(GetSummitFeedbackListDocument, options);
        }
export type GetSummitFeedbackListQueryHookResult = ReturnType<typeof useGetSummitFeedbackListQuery>;
export type GetSummitFeedbackListLazyQueryHookResult = ReturnType<typeof useGetSummitFeedbackListLazyQuery>;
export type GetSummitFeedbackListQueryResult = Apollo.QueryResult<GetSummitFeedbackListQuery, GetSummitFeedbackListQueryVariables>;
export const GetSummitAttendanceListDocument = gql`
    query GetSummitAttendanceList($getStaffSummitAttendanceListRequest: GetStaffSummitAttendanceListRequest!, $cursor: String) {
  staffUsers(
    first: 20
    getStaffSummitAttendanceListRequest: $getStaffSummitAttendanceListRequest
    after: $cursor
  ) {
    totalCount
    edges {
      node {
        id
        firstName
        lastName
        profileImgSmUrl
        summitSessionCount
        title
        primaryEmail
        isTrainer
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetSummitAttendanceListQuery__
 *
 * To run a query within a React component, call `useGetSummitAttendanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummitAttendanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummitAttendanceListQuery({
 *   variables: {
 *      getStaffSummitAttendanceListRequest: // value for 'getStaffSummitAttendanceListRequest'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetSummitAttendanceListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSummitAttendanceListQuery, GetSummitAttendanceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSummitAttendanceListQuery, GetSummitAttendanceListQueryVariables>(GetSummitAttendanceListDocument, options);
      }
export function useGetSummitAttendanceListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSummitAttendanceListQuery, GetSummitAttendanceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSummitAttendanceListQuery, GetSummitAttendanceListQueryVariables>(GetSummitAttendanceListDocument, options);
        }
export type GetSummitAttendanceListQueryHookResult = ReturnType<typeof useGetSummitAttendanceListQuery>;
export type GetSummitAttendanceListLazyQueryHookResult = ReturnType<typeof useGetSummitAttendanceListLazyQuery>;
export type GetSummitAttendanceListQueryResult = Apollo.QueryResult<GetSummitAttendanceListQuery, GetSummitAttendanceListQueryVariables>;
export const GetStaffPeriodicTaskListDocument = gql`
    query GetStaffPeriodicTaskList {
  staffPeriodictasks {
    totalCount
    edges {
      node {
        id
        kwargs
        clocked {
          clockedTime
        }
      }
    }
  }
}
    `;

/**
 * __useGetStaffPeriodicTaskListQuery__
 *
 * To run a query within a React component, call `useGetStaffPeriodicTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffPeriodicTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffPeriodicTaskListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffPeriodicTaskListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffPeriodicTaskListQuery, GetStaffPeriodicTaskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffPeriodicTaskListQuery, GetStaffPeriodicTaskListQueryVariables>(GetStaffPeriodicTaskListDocument, options);
      }
export function useGetStaffPeriodicTaskListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffPeriodicTaskListQuery, GetStaffPeriodicTaskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffPeriodicTaskListQuery, GetStaffPeriodicTaskListQueryVariables>(GetStaffPeriodicTaskListDocument, options);
        }
export type GetStaffPeriodicTaskListQueryHookResult = ReturnType<typeof useGetStaffPeriodicTaskListQuery>;
export type GetStaffPeriodicTaskListLazyQueryHookResult = ReturnType<typeof useGetStaffPeriodicTaskListLazyQuery>;
export type GetStaffPeriodicTaskListQueryResult = Apollo.QueryResult<GetStaffPeriodicTaskListQuery, GetStaffPeriodicTaskListQueryVariables>;
export const GetCurriculumListDocument = gql`
    query GetCurriculumList {
  staffSkillModules {
    edges {
      node {
        id
        order
        name
        description
        isActive
        canBeReviewed
        activeSkillList {
          edges {
            node {
              id
              order
              name
              description
              isPublished
              isActive
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurriculumListQuery__
 *
 * To run a query within a React component, call `useGetCurriculumListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurriculumListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurriculumListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurriculumListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurriculumListQuery, GetCurriculumListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurriculumListQuery, GetCurriculumListQueryVariables>(GetCurriculumListDocument, options);
      }
export function useGetCurriculumListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurriculumListQuery, GetCurriculumListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurriculumListQuery, GetCurriculumListQueryVariables>(GetCurriculumListDocument, options);
        }
export type GetCurriculumListQueryHookResult = ReturnType<typeof useGetCurriculumListQuery>;
export type GetCurriculumListLazyQueryHookResult = ReturnType<typeof useGetCurriculumListLazyQuery>;
export type GetCurriculumListQueryResult = Apollo.QueryResult<GetCurriculumListQuery, GetCurriculumListQueryVariables>;
export const GetSkillModuleDetailDocument = gql`
    query GetSkillModuleDetail($getSkillModuleDetailRequest: GetSkillModuleDetailRequest!) {
  skillModule(getSkillModuleDetailRequest: $getSkillModuleDetailRequest) {
    id
    order
    name
    description
    isActive
    canBeReviewed
  }
}
    `;

/**
 * __useGetSkillModuleDetailQuery__
 *
 * To run a query within a React component, call `useGetSkillModuleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillModuleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillModuleDetailQuery({
 *   variables: {
 *      getSkillModuleDetailRequest: // value for 'getSkillModuleDetailRequest'
 *   },
 * });
 */
export function useGetSkillModuleDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSkillModuleDetailQuery, GetSkillModuleDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSkillModuleDetailQuery, GetSkillModuleDetailQueryVariables>(GetSkillModuleDetailDocument, options);
      }
export function useGetSkillModuleDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSkillModuleDetailQuery, GetSkillModuleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSkillModuleDetailQuery, GetSkillModuleDetailQueryVariables>(GetSkillModuleDetailDocument, options);
        }
export type GetSkillModuleDetailQueryHookResult = ReturnType<typeof useGetSkillModuleDetailQuery>;
export type GetSkillModuleDetailLazyQueryHookResult = ReturnType<typeof useGetSkillModuleDetailLazyQuery>;
export type GetSkillModuleDetailQueryResult = Apollo.QueryResult<GetSkillModuleDetailQuery, GetSkillModuleDetailQueryVariables>;
export const GetActiveSummitListDocument = gql`
    query GetActiveSummitList($isStaff: Boolean) {
  userActiveSummits(isStaff: $isStaff) {
    totalCount
    edges {
      node {
        id
        name
        startDate
        endDate
        imageUrl
        skillModules {
          id
        }
        introVideoUrl
        description
        timeWindows {
          edges {
            node {
              id
              startTime
              endTime
              text
              order
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetActiveSummitListQuery__
 *
 * To run a query within a React component, call `useGetActiveSummitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSummitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSummitListQuery({
 *   variables: {
 *      isStaff: // value for 'isStaff'
 *   },
 * });
 */
export function useGetActiveSummitListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActiveSummitListQuery, GetActiveSummitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActiveSummitListQuery, GetActiveSummitListQueryVariables>(GetActiveSummitListDocument, options);
      }
export function useGetActiveSummitListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveSummitListQuery, GetActiveSummitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActiveSummitListQuery, GetActiveSummitListQueryVariables>(GetActiveSummitListDocument, options);
        }
export type GetActiveSummitListQueryHookResult = ReturnType<typeof useGetActiveSummitListQuery>;
export type GetActiveSummitListLazyQueryHookResult = ReturnType<typeof useGetActiveSummitListLazyQuery>;
export type GetActiveSummitListQueryResult = Apollo.QueryResult<GetActiveSummitListQuery, GetActiveSummitListQueryVariables>;
export const GetActiveSummitCurriculumDocument = gql`
    query GetActiveSummitCurriculum {
  userActiveSummits(isStaff: false) {
    edges {
      node {
        id
        name
        startDate
        endDate
        skillModules {
          id
          order
          name
          publishedSkillList {
            edges {
              node {
                id
                order
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetActiveSummitCurriculumQuery__
 *
 * To run a query within a React component, call `useGetActiveSummitCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSummitCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSummitCurriculumQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSummitCurriculumQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActiveSummitCurriculumQuery, GetActiveSummitCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActiveSummitCurriculumQuery, GetActiveSummitCurriculumQueryVariables>(GetActiveSummitCurriculumDocument, options);
      }
export function useGetActiveSummitCurriculumLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveSummitCurriculumQuery, GetActiveSummitCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActiveSummitCurriculumQuery, GetActiveSummitCurriculumQueryVariables>(GetActiveSummitCurriculumDocument, options);
        }
export type GetActiveSummitCurriculumQueryHookResult = ReturnType<typeof useGetActiveSummitCurriculumQuery>;
export type GetActiveSummitCurriculumLazyQueryHookResult = ReturnType<typeof useGetActiveSummitCurriculumLazyQuery>;
export type GetActiveSummitCurriculumQueryResult = Apollo.QueryResult<GetActiveSummitCurriculumQuery, GetActiveSummitCurriculumQueryVariables>;
export const GetPastSummitCurriculumDocument = gql`
    query GetPastSummitCurriculum {
  userPastSummits(first: 3, isStaff: false) {
    edges {
      node {
        id
        name
        startDate
        endDate
        skillModules {
          id
          order
          name
          publishedSkillList {
            edges {
              node {
                id
                order
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPastSummitCurriculumQuery__
 *
 * To run a query within a React component, call `useGetPastSummitCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastSummitCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastSummitCurriculumQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPastSummitCurriculumQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPastSummitCurriculumQuery, GetPastSummitCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPastSummitCurriculumQuery, GetPastSummitCurriculumQueryVariables>(GetPastSummitCurriculumDocument, options);
      }
export function useGetPastSummitCurriculumLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPastSummitCurriculumQuery, GetPastSummitCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPastSummitCurriculumQuery, GetPastSummitCurriculumQueryVariables>(GetPastSummitCurriculumDocument, options);
        }
export type GetPastSummitCurriculumQueryHookResult = ReturnType<typeof useGetPastSummitCurriculumQuery>;
export type GetPastSummitCurriculumLazyQueryHookResult = ReturnType<typeof useGetPastSummitCurriculumLazyQuery>;
export type GetPastSummitCurriculumQueryResult = Apollo.QueryResult<GetPastSummitCurriculumQuery, GetPastSummitCurriculumQueryVariables>;
export const GetStaffActiveSummitListDocument = gql`
    query GetStaffActiveSummitList($isStaff: Boolean) {
  userActiveSummits(isStaff: $isStaff) {
    totalCount
    edges {
      node {
        id
        name
        startDate
        endDate
        imageUrl
        isPublished
        skillModules {
          id
        }
        cohorts {
          id
          name
          cohortType
          userCount
          userproxyCount
        }
        introVideoUrl
        description
        matchAlgorithm
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetStaffActiveSummitListQuery__
 *
 * To run a query within a React component, call `useGetStaffActiveSummitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffActiveSummitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffActiveSummitListQuery({
 *   variables: {
 *      isStaff: // value for 'isStaff'
 *   },
 * });
 */
export function useGetStaffActiveSummitListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffActiveSummitListQuery, GetStaffActiveSummitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffActiveSummitListQuery, GetStaffActiveSummitListQueryVariables>(GetStaffActiveSummitListDocument, options);
      }
export function useGetStaffActiveSummitListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffActiveSummitListQuery, GetStaffActiveSummitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffActiveSummitListQuery, GetStaffActiveSummitListQueryVariables>(GetStaffActiveSummitListDocument, options);
        }
export type GetStaffActiveSummitListQueryHookResult = ReturnType<typeof useGetStaffActiveSummitListQuery>;
export type GetStaffActiveSummitListLazyQueryHookResult = ReturnType<typeof useGetStaffActiveSummitListLazyQuery>;
export type GetStaffActiveSummitListQueryResult = Apollo.QueryResult<GetStaffActiveSummitListQuery, GetStaffActiveSummitListQueryVariables>;
export const GetPastSummitListDocument = gql`
    query GetPastSummitList($isStaff: Boolean, $cursor: String) {
  userPastSummits(first: 15, isStaff: $isStaff, after: $cursor) {
    totalCount
    edges {
      node {
        id
        name
        startDate
        endDate
        imageUrl
        isPublished
        skillModules {
          id
        }
        introVideoUrl
        description
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPastSummitListQuery__
 *
 * To run a query within a React component, call `useGetPastSummitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastSummitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastSummitListQuery({
 *   variables: {
 *      isStaff: // value for 'isStaff'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetPastSummitListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPastSummitListQuery, GetPastSummitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPastSummitListQuery, GetPastSummitListQueryVariables>(GetPastSummitListDocument, options);
      }
export function useGetPastSummitListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPastSummitListQuery, GetPastSummitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPastSummitListQuery, GetPastSummitListQueryVariables>(GetPastSummitListDocument, options);
        }
export type GetPastSummitListQueryHookResult = ReturnType<typeof useGetPastSummitListQuery>;
export type GetPastSummitListLazyQueryHookResult = ReturnType<typeof useGetPastSummitListLazyQuery>;
export type GetPastSummitListQueryResult = Apollo.QueryResult<GetPastSummitListQuery, GetPastSummitListQueryVariables>;
export const GetStaffPastSummitListDocument = gql`
    query GetStaffPastSummitList($isStaff: Boolean, $cursor: String) {
  userPastSummits(first: 8, isStaff: $isStaff, after: $cursor) {
    totalCount
    edges {
      node {
        id
        name
        startDate
        endDate
        imageUrl
        skillModules {
          id
        }
        cohorts {
          id
          name
          cohortType
          userCount
          userproxyCount
        }
        introVideoUrl
        description
        matchAlgorithm
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetStaffPastSummitListQuery__
 *
 * To run a query within a React component, call `useGetStaffPastSummitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffPastSummitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffPastSummitListQuery({
 *   variables: {
 *      isStaff: // value for 'isStaff'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetStaffPastSummitListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffPastSummitListQuery, GetStaffPastSummitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffPastSummitListQuery, GetStaffPastSummitListQueryVariables>(GetStaffPastSummitListDocument, options);
      }
export function useGetStaffPastSummitListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffPastSummitListQuery, GetStaffPastSummitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffPastSummitListQuery, GetStaffPastSummitListQueryVariables>(GetStaffPastSummitListDocument, options);
        }
export type GetStaffPastSummitListQueryHookResult = ReturnType<typeof useGetStaffPastSummitListQuery>;
export type GetStaffPastSummitListLazyQueryHookResult = ReturnType<typeof useGetStaffPastSummitListLazyQuery>;
export type GetStaffPastSummitListQueryResult = Apollo.QueryResult<GetStaffPastSummitListQuery, GetStaffPastSummitListQueryVariables>;
export const GetStaffCohortsDocument = gql`
    query GetStaffCohorts($cursor: String) {
  staffCohorts(first: 15, after: $cursor) {
    edges {
      node {
        id
        name
        cohortType
        userCount
        userproxyCount
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetStaffCohortsQuery__
 *
 * To run a query within a React component, call `useGetStaffCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffCohortsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetStaffCohortsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaffCohortsQuery, GetStaffCohortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStaffCohortsQuery, GetStaffCohortsQueryVariables>(GetStaffCohortsDocument, options);
      }
export function useGetStaffCohortsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaffCohortsQuery, GetStaffCohortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStaffCohortsQuery, GetStaffCohortsQueryVariables>(GetStaffCohortsDocument, options);
        }
export type GetStaffCohortsQueryHookResult = ReturnType<typeof useGetStaffCohortsQuery>;
export type GetStaffCohortsLazyQueryHookResult = ReturnType<typeof useGetStaffCohortsLazyQuery>;
export type GetStaffCohortsQueryResult = Apollo.QueryResult<GetStaffCohortsQuery, GetStaffCohortsQueryVariables>;
export const GetQuotaReportDocument = gql`
    query GetQuotaReport($userId: GlobalID) {
  quotaReport(userId: $userId) {
    quotaCompletedSessions
    monthlyCompletedSessions
    activeSummitCompletion {
      totalActiveSkills
      completedSkills
      summit {
        id
        name
      }
    }
    pastSummitCompletion {
      totalActiveSkills
      completedSkills
      summit {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetQuotaReportQuery__
 *
 * To run a query within a React component, call `useGetQuotaReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotaReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotaReportQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetQuotaReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuotaReportQuery, GetQuotaReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuotaReportQuery, GetQuotaReportQueryVariables>(GetQuotaReportDocument, options);
      }
export function useGetQuotaReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuotaReportQuery, GetQuotaReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuotaReportQuery, GetQuotaReportQueryVariables>(GetQuotaReportDocument, options);
        }
export type GetQuotaReportQueryHookResult = ReturnType<typeof useGetQuotaReportQuery>;
export type GetQuotaReportLazyQueryHookResult = ReturnType<typeof useGetQuotaReportLazyQuery>;
export type GetQuotaReportQueryResult = Apollo.QueryResult<GetQuotaReportQuery, GetQuotaReportQueryVariables>;
export const GetStoreUsersParticipationDocument = gql`
    query GetStoreUsersParticipation($getUserStoreRequest: GetUserStoreRequest!, $first: Int, $cursor: String, $isOnTrack: Boolean) {
  store(getUserStoreRequest: $getUserStoreRequest) {
    id
    name
    quotaProgress
    quotaTarget
    isOnTrack
    childrenCompletedQuota
    userCount
    users(isOnTrack: $isOnTrack, first: $first, after: $cursor) {
      edges {
        node {
          id
          firstName
          lastName
          quotaProgress
          quotaTarget
          isOnTrack
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    leader {
      id
      firstName
      lastName
      profileImgSmUrl
      profileImgLgUrl
      title
      hireDate
    }
    district {
      id
      name
    }
    region {
      id
      name
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStoreUsersParticipationQuery__
 *
 * To run a query within a React component, call `useGetStoreUsersParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreUsersParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreUsersParticipationQuery({
 *   variables: {
 *      getUserStoreRequest: // value for 'getUserStoreRequest'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      isOnTrack: // value for 'isOnTrack'
 *   },
 * });
 */
export function useGetStoreUsersParticipationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStoreUsersParticipationQuery, GetStoreUsersParticipationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStoreUsersParticipationQuery, GetStoreUsersParticipationQueryVariables>(GetStoreUsersParticipationDocument, options);
      }
export function useGetStoreUsersParticipationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStoreUsersParticipationQuery, GetStoreUsersParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStoreUsersParticipationQuery, GetStoreUsersParticipationQueryVariables>(GetStoreUsersParticipationDocument, options);
        }
export type GetStoreUsersParticipationQueryHookResult = ReturnType<typeof useGetStoreUsersParticipationQuery>;
export type GetStoreUsersParticipationLazyQueryHookResult = ReturnType<typeof useGetStoreUsersParticipationLazyQuery>;
export type GetStoreUsersParticipationQueryResult = Apollo.QueryResult<GetStoreUsersParticipationQuery, GetStoreUsersParticipationQueryVariables>;
export const GetDistrictStoresParticipationDocument = gql`
    query GetDistrictStoresParticipation($getUserDistrictRequest: GetUserDistrictRequest!, $first: Int, $cursor: String, $isOnTrack: Boolean) {
  district(getUserDistrictRequest: $getUserDistrictRequest) {
    id
    name
    quotaProgress
    quotaTarget
    isOnTrack
    childrenCompletedQuota
    storeCount
    stores(isOnTrack: $isOnTrack, first: $first, after: $cursor) {
      edges {
        node {
          id
          name
          quotaProgress
          quotaTarget
          isOnTrack
          participatingUsers
          userCount
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    leader {
      id
      firstName
      lastName
      profileImgSmUrl
      profileImgLgUrl
      title
      hireDate
    }
    region {
      id
      name
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDistrictStoresParticipationQuery__
 *
 * To run a query within a React component, call `useGetDistrictStoresParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictStoresParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictStoresParticipationQuery({
 *   variables: {
 *      getUserDistrictRequest: // value for 'getUserDistrictRequest'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      isOnTrack: // value for 'isOnTrack'
 *   },
 * });
 */
export function useGetDistrictStoresParticipationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDistrictStoresParticipationQuery, GetDistrictStoresParticipationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDistrictStoresParticipationQuery, GetDistrictStoresParticipationQueryVariables>(GetDistrictStoresParticipationDocument, options);
      }
export function useGetDistrictStoresParticipationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDistrictStoresParticipationQuery, GetDistrictStoresParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDistrictStoresParticipationQuery, GetDistrictStoresParticipationQueryVariables>(GetDistrictStoresParticipationDocument, options);
        }
export type GetDistrictStoresParticipationQueryHookResult = ReturnType<typeof useGetDistrictStoresParticipationQuery>;
export type GetDistrictStoresParticipationLazyQueryHookResult = ReturnType<typeof useGetDistrictStoresParticipationLazyQuery>;
export type GetDistrictStoresParticipationQueryResult = Apollo.QueryResult<GetDistrictStoresParticipationQuery, GetDistrictStoresParticipationQueryVariables>;
export const GetRegionDistrictsParticipationDocument = gql`
    query GetRegionDistrictsParticipation($getUserRegionRequest: GetUserRegionRequest!, $first: Int, $cursor: String, $isOnTrack: Boolean) {
  region(getUserRegionRequest: $getUserRegionRequest) {
    id
    name
    quotaProgress
    quotaTarget
    isOnTrack
    childrenCompletedQuota
    districtCount
    districts(isOnTrack: $isOnTrack, first: $first, after: $cursor) {
      edges {
        node {
          id
          name
          quotaProgress
          quotaTarget
          isOnTrack
          participatingUsers
          userCount
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    leader {
      id
      firstName
      lastName
      profileImgSmUrl
      profileImgLgUrl
      title
      hireDate
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRegionDistrictsParticipationQuery__
 *
 * To run a query within a React component, call `useGetRegionDistrictsParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionDistrictsParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionDistrictsParticipationQuery({
 *   variables: {
 *      getUserRegionRequest: // value for 'getUserRegionRequest'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      isOnTrack: // value for 'isOnTrack'
 *   },
 * });
 */
export function useGetRegionDistrictsParticipationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRegionDistrictsParticipationQuery, GetRegionDistrictsParticipationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRegionDistrictsParticipationQuery, GetRegionDistrictsParticipationQueryVariables>(GetRegionDistrictsParticipationDocument, options);
      }
export function useGetRegionDistrictsParticipationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegionDistrictsParticipationQuery, GetRegionDistrictsParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRegionDistrictsParticipationQuery, GetRegionDistrictsParticipationQueryVariables>(GetRegionDistrictsParticipationDocument, options);
        }
export type GetRegionDistrictsParticipationQueryHookResult = ReturnType<typeof useGetRegionDistrictsParticipationQuery>;
export type GetRegionDistrictsParticipationLazyQueryHookResult = ReturnType<typeof useGetRegionDistrictsParticipationLazyQuery>;
export type GetRegionDistrictsParticipationQueryResult = Apollo.QueryResult<GetRegionDistrictsParticipationQuery, GetRegionDistrictsParticipationQueryVariables>;
export const GetOrgRegionsParticipationDocument = gql`
    query GetOrgRegionsParticipation($first: Int, $cursor: String, $isOnTrack: Boolean) {
  user {
    organization {
      id
      name
      quotaProgress
      quotaTarget
      isOnTrack
      childrenCompletedQuota
      regionCount
      regions(isOnTrack: $isOnTrack, first: $first, after: $cursor) {
        edges {
          node {
            id
            name
            quotaProgress
            quotaTarget
            isOnTrack
            participatingUsers
            userCount
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrgRegionsParticipationQuery__
 *
 * To run a query within a React component, call `useGetOrgRegionsParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRegionsParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRegionsParticipationQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      isOnTrack: // value for 'isOnTrack'
 *   },
 * });
 */
export function useGetOrgRegionsParticipationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrgRegionsParticipationQuery, GetOrgRegionsParticipationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrgRegionsParticipationQuery, GetOrgRegionsParticipationQueryVariables>(GetOrgRegionsParticipationDocument, options);
      }
export function useGetOrgRegionsParticipationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrgRegionsParticipationQuery, GetOrgRegionsParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrgRegionsParticipationQuery, GetOrgRegionsParticipationQueryVariables>(GetOrgRegionsParticipationDocument, options);
        }
export type GetOrgRegionsParticipationQueryHookResult = ReturnType<typeof useGetOrgRegionsParticipationQuery>;
export type GetOrgRegionsParticipationLazyQueryHookResult = ReturnType<typeof useGetOrgRegionsParticipationLazyQuery>;
export type GetOrgRegionsParticipationQueryResult = Apollo.QueryResult<GetOrgRegionsParticipationQuery, GetOrgRegionsParticipationQueryVariables>;
export const GetOrgQuotaCompletionDocument = gql`
    query GetOrgQuotaCompletion {
  user {
    organization {
      quotaProgress
      quotaTarget
    }
  }
}
    `;

/**
 * __useGetOrgQuotaCompletionQuery__
 *
 * To run a query within a React component, call `useGetOrgQuotaCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgQuotaCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgQuotaCompletionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgQuotaCompletionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrgQuotaCompletionQuery, GetOrgQuotaCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrgQuotaCompletionQuery, GetOrgQuotaCompletionQueryVariables>(GetOrgQuotaCompletionDocument, options);
      }
export function useGetOrgQuotaCompletionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrgQuotaCompletionQuery, GetOrgQuotaCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrgQuotaCompletionQuery, GetOrgQuotaCompletionQueryVariables>(GetOrgQuotaCompletionDocument, options);
        }
export type GetOrgQuotaCompletionQueryHookResult = ReturnType<typeof useGetOrgQuotaCompletionQuery>;
export type GetOrgQuotaCompletionLazyQueryHookResult = ReturnType<typeof useGetOrgQuotaCompletionLazyQuery>;
export type GetOrgQuotaCompletionQueryResult = Apollo.QueryResult<GetOrgQuotaCompletionQuery, GetOrgQuotaCompletionQueryVariables>;
export const GetUserParticipationDocument = gql`
    query GetUserParticipation($userId: GlobalID!) {
  user(userId: $userId) {
    id
    name
    firstName
    lastName
    quotaTarget
    quotaProgress
    isOnTrack
    organization {
      id
      name
    }
    district {
      id
      name
    }
    region {
      id
      name
    }
    store {
      id
      name
      leader {
        id
        firstName
        lastName
        profileImgSmUrl
        profileImgLgUrl
        title
        hireDate
      }
    }
  }
}
    `;

/**
 * __useGetUserParticipationQuery__
 *
 * To run a query within a React component, call `useGetUserParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserParticipationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserParticipationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserParticipationQuery, GetUserParticipationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserParticipationQuery, GetUserParticipationQueryVariables>(GetUserParticipationDocument, options);
      }
export function useGetUserParticipationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserParticipationQuery, GetUserParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserParticipationQuery, GetUserParticipationQueryVariables>(GetUserParticipationDocument, options);
        }
export type GetUserParticipationQueryHookResult = ReturnType<typeof useGetUserParticipationQuery>;
export type GetUserParticipationLazyQueryHookResult = ReturnType<typeof useGetUserParticipationLazyQuery>;
export type GetUserParticipationQueryResult = Apollo.QueryResult<GetUserParticipationQuery, GetUserParticipationQueryVariables>;
export const GetKudosDocument = gql`
    query GetKudos($getKudosRequest: GetKudosRequest2!, $first: Int, $cursor: String) {
  kudos2(getKudosRequest: $getKudosRequest, first: $first, after: $cursor) {
    edges {
      node {
        id
        categoryHelpfulTips
        categoryKnowledgeable
        categoryGoodConversation
        categoryFriendly
        message
        created
        sender {
          id
          firstName
          lastName
          profileImgSmUrl
        }
        recipient {
          id
          firstName
          lastName
          profileImgSmUrl
        }
        session {
          id
          thumbnailUrl
          duration
          archiveUrl
        }
        approved
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetKudosQuery__
 *
 * To run a query within a React component, call `useGetKudosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKudosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKudosQuery({
 *   variables: {
 *      getKudosRequest: // value for 'getKudosRequest'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetKudosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetKudosQuery, GetKudosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetKudosQuery, GetKudosQueryVariables>(GetKudosDocument, options);
      }
export function useGetKudosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetKudosQuery, GetKudosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetKudosQuery, GetKudosQueryVariables>(GetKudosDocument, options);
        }
export type GetKudosQueryHookResult = ReturnType<typeof useGetKudosQuery>;
export type GetKudosLazyQueryHookResult = ReturnType<typeof useGetKudosLazyQuery>;
export type GetKudosQueryResult = Apollo.QueryResult<GetKudosQuery, GetKudosQueryVariables>;